// // // // // // import {
// // // // // //   Box,
// // // // // //   Flex,
// // // // // //   IconButton,
// // // // // //   Button,
// // // // // //   Input,
// // // // // //   Text,
// // // // // //   Tooltip,
// // // // // //   useDisclosure,
// // // // // //   useToast
// // // // // // } from "@chakra-ui/react";

// // // // // // import {
// // // // // //   FiEdit,
// // // // // //   FiPrinter,
// // // // // //   FiTrash2,
// // // // // //   FiSearch
// // // // // // } from "react-icons/fi";

// // // // // // import * as XLSX from "xlsx";
// // // // // // import { saveAs } from "file-saver";

// // // // // // import { FiX } from "react-icons/fi";

// // // // // // import { useEffect, useMemo, useState } from "react";

// // // // // // import DataTable from "react-data-table-component";

// // // // // // import ContentCard from "../../components/common/ContentCard";
// // // // // // import { PageHeader } from "../../components/common/PageHeader";
// // // // // // import { FichaService } from "../../services/ficha.service";


// // // // // // import FormModal from "./FormModal";

// // // // // // export function exportGridToExcel(
// // // // // //   rows: any[],
// // // // // //   fileName = "dados.xlsx"
// // // // // // ) {
// // // // // //   if (!rows || rows.length === 0) return;

// // // // // //   // pega TODAS as chaves reais do objeto
// // // // // //   const keys = Object.keys(rows[0]);

// // // // // //   const formatted = rows.map((row) => {
// // // // // //     const obj: any = {};

// // // // // //     keys.forEach((key) => {
// // // // // //       const value = row?.[key];

// // // // // //       obj[key] =
// // // // // //         value === null || value === undefined
// // // // // //           ? ""
// // // // // //           : typeof value === "object"
// // // // // //             ? JSON.stringify(value)
// // // // // //             : value;
// // // // // //     });

// // // // // //     return obj;
// // // // // //   });

// // // // // //   const worksheet = XLSX.utils.json_to_sheet(formatted);
// // // // // //   const workbook = XLSX.utils.book_new();

// // // // // //   XLSX.utils.book_append_sheet(workbook, worksheet, "Dados");

// // // // // //   const buffer = XLSX.write(workbook, {
// // // // // //     bookType: "xlsx",
// // // // // //     type: "array"
// // // // // //   });

// // // // // //   const file = new Blob([buffer], {
// // // // // //     type: "application/octet-stream"
// // // // // //   });

// // // // // //   saveAs(file, fileName);
// // // // // // }


// // // // // // export default function ListPage() {



// // // // // //   const toast = useToast();
// // // // // //   const { isOpen, onOpen, onClose } = useDisclosure();

// // // // // //   const [rows, setRows] = useState<any[]>([]);
// // // // // //   const [editing, setEditing] = useState<any>(null);
// // // // // //   const [loading, setLoading] = useState(false);

// // // // // //   const [filters, setFilters] = useState({
// // // // // //     nome: "",
// // // // // //     cpf: "",
// // // // // //     rg: "",
// // // // // //     titulo: "",
// // // // // //     sus: "",
// // // // // //     contato: "",

// // // // // //     nome_mae: "",
// // // // // //     data_nascimento: "",

// // // // // //     lideranca: "",
// // // // // //     zona: "",
// // // // // //     sessao: "",

// // // // // //     endereco: "",
// // // // // //     bairro: "",
// // // // // //     cidade: "",
// // // // // //     uf: "",

// // // // // //     observacao: ""
// // // // // //   });

// // // // // //   const [openFilter, setOpenFilter] = useState<string | null>(null);


// // // // // //   async function loadData() {
// // // // // //     try {
// // // // // //       setLoading(true);
// // // // // //       const data = await FichaService.findAll();
// // // // // //       console.log(data);
// // // // // //       setRows(data);
// // // // // //     } catch {
// // // // // //       toast({ title: "Erro ao carregar fichas", status: "error" });
// // // // // //     } finally {
// // // // // //       setLoading(false);
// // // // // //     }
// // // // // //   }

// // // // // //   useEffect(() => {
// // // // // //     loadData();
// // // // // //   }, []);

// // // // // //   async function handleDelete(id: number) {
// // // // // //     if (!confirm("Deseja excluir esta ficha?")) return;

// // // // // //     try {
// // // // // //       await FichaService.delete(id);
// // // // // //       toast({ title: "Ficha excluída", status: "success" });
// // // // // //       loadData();
// // // // // //     } catch {
// // // // // //       toast({ title: "Erro ao excluir ficha", status: "error" });
// // // // // //     }
// // // // // //   }

// // // // // //   function handlePrint(ficha: any) {

// // // // // //     const win = window.open("", "_blank", "width=900,height=700");

// // // // // //     if (!win) return;

// // // // // //     win.document.write(`
// // // // // //     <html>
// // // // // //       <head>
// // // // // //         <title>Ficha</title>

// // // // // //         <style>
// // // // // //           body {
// // // // // //             font-family: Arial, sans-serif;
// // // // // //             padding: 20px;
// // // // // //           }

// // // // // //           .container {
// // // // // //             border: 1px solid #000;
// // // // // //             padding: 20px;
// // // // // //           }

// // // // // //           h2 {
// // // // // //             text-align: center;
// // // // // //             margin-bottom: 20px;
// // // // // //           }

// // // // // //           .row {
// // // // // //             margin-bottom: 8px;
// // // // // //             font-size: 14px;
// // // // // //           }

// // // // // //           .label {
// // // // // //             font-weight: bold;
// // // // // //           }

// // // // // //           .grid {
// // // // // //             display: grid;
// // // // // //             grid-template-columns: 1fr 1fr;
// // // // // //             gap: 10px;
// // // // // //           }

// // // // // //           .section {
// // // // // //             margin-top: 15px;
// // // // // //             padding-top: 10px;
// // // // // //             border-top: 1px solid #000;
// // // // // //           }
// // // // // //         </style>

// // // // // //       </head>

// // // // // //       <body>

// // // // // //         <div class="container">

// // // // // //           <h2>FICHA DE CADASTRO</h2>

// // // // // //           <div class="grid">

// // // // // //             <div class="row"><span class="label">Nome:</span> ${ficha.nome || ""}</div>
// // // // // //             <div class="row"><span class="label">CPF:</span> ${ficha.cpf || ""}</div>

// // // // // //             <div class="row"><span class="label">RG:</span> ${ficha.rg || ""}</div>
// // // // // //             <div class="row"><span class="label">Título:</span> ${ficha.titulo || ""}</div>

// // // // // //             <div class="row"><span class="label">SUS:</span> ${ficha.cartao_sus || ""}</div>
// // // // // //             <div class="row"><span class="label">Nascimento:</span> ${ficha.data_nascimento || ""}</div>

// // // // // //             <div class="row"><span class="label">Mãe:</span> ${ficha.nome_mae || ""}</div>
// // // // // //             <div class="row"><span class="label">Contato:</span> ${ficha.contato || ""}</div>

// // // // // //           </div>

// // // // // //           <div class="section">

// // // // // //             <div class="row">
// // // // // //               <span class="label">Liderança:</span>
// // // // // //               ${ficha.numero_lideranca || ""} - ${ficha.lideranca_nome || ""}
// // // // // //             </div>

// // // // // //             <div class="row">
// // // // // //               <span class="label">Zona:</span>
// // // // // //               ${ficha.zona_numero || ""}
// // // // // //             </div>

// // // // // //             <div class="row">
// // // // // //               <span class="label">Sessão:</span>
// // // // // //               ${ficha.sessao_numero || ""} - ${ficha.sessao_descricao || ""}
// // // // // //             </div>

// // // // // //           </div>

// // // // // //           <div class="section">

// // // // // //             <div class="row">
// // // // // //               <span class="label">Endereço:</span>
// // // // // //               ${ficha.endereco || ""}, ${ficha.numero || ""}
// // // // // //             </div>

// // // // // //             <div class="row">
// // // // // //               <span class="label">Bairro:</span> ${ficha.bairro || ""}
// // // // // //             </div>

// // // // // //             <div class="row">
// // // // // //               <span class="label">Cidade:</span> ${ficha.cidade || ""}
// // // // // //             </div>

// // // // // //             <div class="row">
// // // // // //               <span class="label">UF:</span> ${ficha.uf || ""}
// // // // // //             </div>

// // // // // //           </div>

// // // // // //           <div class="section">

// // // // // //             <div class="row">
// // // // // //               <span class="label">Observação:</span><br/>
// // // // // //               ${ficha.observacao || ""}
// // // // // //             </div>

// // // // // //           </div>

// // // // // //         </div>

// // // // // //         <script>
// // // // // //           window.onload = function () {
// // // // // //             setTimeout(() => {
// // // // // //               window.print();
// // // // // //             }, 300);
// // // // // //           };
// // // // // //         </script>

// // // // // //       </body>
// // // // // //     </html>
// // // // // //   `);

// // // // // //     win.document.close();
// // // // // //     win.focus();
// // // // // //   }

// // // // // //   const filtered = useMemo(() => {
// // // // // //     // return 
// // // // // //     console.log(rows, filters);

// // // // // //     const ros = rows.filter((item) => {

// // // // // //       const nome = item.nome || "";
// // // // // //       const cpf = item.cpf || "";
// // // // // //       const titulo = item.titulo || "";
// // // // // //       const rg = item.rg || "";
// // // // // //       const sus = item.cartao_sus || "";
// // // // // //       const contato = item.contato || "";
// // // // // //       const mae = item.nome_mae || "";
// // // // // //       const bairro = item.bairro || "";
// // // // // //       const cidade = item.cidade || "";
// // // // // //       const uf = item.uf || "";
// // // // // //       const endereco = item.endereco || "";
// // // // // //       const observacao = item.observacao || "";

// // // // // //       return (
// // // // // //         nome.toLowerCase().includes(filters.nome.toLowerCase()) &&
// // // // // //         cpf.toLowerCase().includes(filters.cpf.toLowerCase()) &&
// // // // // //         titulo.toLowerCase().includes(filters.titulo.toLowerCase()) &&
// // // // // //         rg.toLowerCase().includes(filters.rg.toLowerCase()) &&
// // // // // //         sus.toLowerCase().includes(filters.sus.toLowerCase()) &&
// // // // // //         contato.toLowerCase().includes(filters.contato.toLowerCase()) &&
// // // // // //         mae.toLowerCase().includes(filters.nome_mae.toLowerCase()) &&
// // // // // //         bairro.toLowerCase().includes(filters.bairro.toLowerCase()) &&
// // // // // //         cidade.toLowerCase().includes(filters.cidade.toLowerCase()) &&
// // // // // //         uf.toLowerCase().includes(filters.uf.toLowerCase()) &&
// // // // // //         endereco.toLowerCase().includes(filters.endereco.toLowerCase()) &&
// // // // // //         observacao.toLowerCase().includes(filters.observacao.toLowerCase())
// // // // // //       );
// // // // // //     });
// // // // // //     console.log(ros);
// // // // // //     return ros;
// // // // // //   }, [rows, filters]);

// // // // // //   function renderFilter(field: string, label: string) {
// // // // // //     return openFilter === field ? (
// // // // // //       <Input
// // // // // //         size="sm"
// // // // // //         autoFocus
// // // // // //         placeholder={`Filtrar ${label}`}
// // // // // //         value={(filters as any)[field]}
// // // // // //         onChange={(e) => {
// // // // // //           console.log(e.target.value, field);
// // // // // //           setFilters({ ...filters, [field]: e.target.value });
// // // // // //           console.log(filters);
// // // // // //         }}
// // // // // //         onBlur={() => setOpenFilter(null)}
// // // // // //       />
// // // // // //     ) : (
// // // // // //       <Flex align="center" gap={2}>
// // // // // //         <Text fontSize="sm" fontWeight="600">
// // // // // //           {label}
// // // // // //         </Text>
// // // // // //         <IconButton
// // // // // //           aria-label="filtro"
// // // // // //           icon={<FiSearch />}
// // // // // //           size="xs"
// // // // // //           variant="ghost"
// // // // // //           onClick={() => setOpenFilter(field)}
// // // // // //         />
// // // // // //       </Flex>
// // // // // //     );
// // // // // //   }

// // // // // //   const columns = [
// // // // // //     { name: renderFilter("nome", "Nome"), selector: (r: any) => r.nome, minWidth: "180px", wrap: true },
// // // // // //     { name: renderFilter("cpf", "CPF"), selector: (r: any) => r.cpf, minWidth: "140px" },
// // // // // //     { name: renderFilter("rg", "RG"), selector: (r: any) => r.rg, minWidth: "120px" },
// // // // // //     { name: renderFilter("titulo", "Título"), selector: (r: any) => r.titulo, minWidth: "120px" },
// // // // // //     { name: renderFilter("sus", "SUS"), selector: (r: any) => r.cartao_sus, minWidth: "140px" },
// // // // // //     { name: renderFilter("data_nascimento", "Nascimento"), selector: (r: any) => r.data_nascimento, minWidth: "140px" },
// // // // // //     { name: renderFilter("nome_mae", "Mãe"), selector: (r: any) => r.nome_mae, minWidth: "160px", wrap: true },
// // // // // //     { name: renderFilter("contato", "Contato"), selector: (r: any) => r.contato, minWidth: "160px", wrap: true },
// // // // // //     { name: renderFilter("lideranca", "Liderança"), selector: (r: any) => r.lideranca_nome, minWidth: "160px", wrap: true },
// // // // // //     { name: renderFilter("zona", "Zona"), selector: (r: any) => r.zona_numero, minWidth: "160px", wrap: true },
// // // // // //     { name: renderFilter("sessao", "Sessão"), selector: (r: any) => r.sessao_numero, minWidth: "160px", wrap: true },
// // // // // //     { name: renderFilter("endereço", "Endereço"), selector: (r: any) => r.endereco, minWidth: "160px", wrap: true },
// // // // // //     { name: renderFilter("bairro", "Bairro"), selector: (r: any) => r.bairro, minWidth: "160px", wrap: true },
// // // // // //     { name: renderFilter("cidade", "Cidade"), selector: (r: any) => r.cidade, minWidth: "160px", wrap: true },
// // // // // //     { name: renderFilter("uf", "UF"), selector: (r: any) => r.uf, minWidth: "160px", wrap: true },

// // // // // //     {
// // // // // //       name: "Obs",
// // // // // //       selector: (r: any) => r.observacao,
// // // // // //       minWidth: "180px",
// // // // // //       wrap: true
// // // // // //     },

// // // // // //     {
// // // // // //       name: "Ações",
// // // // // //       width: "140px",
// // // // // //       cell: (row: any) => (
// // // // // //         <Flex gap={2}>
// // // // // //           <IconButton
// // // // // //             aria-label="editar"
// // // // // //             icon={<FiEdit />}
// // // // // //             size="sm"
// // // // // //             colorScheme="blue"
// // // // // //             onClick={() => {
// // // // // //               setEditing(row);
// // // // // //               onOpen();
// // // // // //             }}
// // // // // //           />

// // // // // //           <IconButton
// // // // // //             aria-label="excluir"
// // // // // //             icon={<FiTrash2 />}
// // // // // //             size="sm"
// // // // // //             colorScheme="red"
// // // // // //             onClick={() => handleDelete(row.id)}
// // // // // //           />

// // // // // //           <Tooltip label="Imprimir">
// // // // // //             <IconButton
// // // // // //               aria-label="imprimir"
// // // // // //               icon={<FiPrinter />}
// // // // // //               size="sm"
// // // // // //               colorScheme="green"
// // // // // //               onClick={() => handlePrint(row)}
// // // // // //             />
// // // // // //           </Tooltip>
// // // // // //         </Flex>
// // // // // //       )
// // // // // //     }
// // // // // //   ];

// // // // // //   const customStyles = {
// // // // // //     headCells: {
// // // // // //       style: {
// // // // // //         fontWeight: "bold",
// // // // // //         fontSize: "13px",
// // // // // //         padding: "10px",
// // // // // //         backgroundColor: "#f8fafc"
// // // // // //       }
// // // // // //     },
// // // // // //     cells: {
// // // // // //       style: {
// // // // // //         fontSize: "13px",
// // // // // //         padding: "8px",
// // // // // //         whiteSpace: "normal",
// // // // // //         wordBreak: "break-word"
// // // // // //       }
// // // // // //     }
// // // // // //   };

// // // // // //   return (
// // // // // //     <Box>
// // // // // //       <PageHeader
// // // // // //         title="Fichas"
// // // // // //         onNew={() => {
// // // // // //           setEditing(null);
// // // // // //           onOpen();
// // // // // //         }}
// // // // // //         actions={
// // // // // //           <>
// // // // // //             <Button
// // // // // //               size="sm"
// // // // // //               variant="outline"
// // // // // //               colorScheme="red"
// // // // // //               onClick={() => {
// // // // // //                 setFilters({
// // // // // //                   nome: "",
// // // // // //                   cpf: "",
// // // // // //                   rg: "",
// // // // // //                   titulo: "",
// // // // // //                   sus: "",
// // // // // //                   contato: "",
// // // // // //                   nome_mae: "",
// // // // // //                   data_nascimento: "",
// // // // // //                   lideranca: "",
// // // // // //                   zona: "",
// // // // // //                   sessao: "",
// // // // // //                   endereco: "",
// // // // // //                   bairro: "",
// // // // // //                   cidade: "",
// // // // // //                   uf: "",
// // // // // //                   observacao: ""
// // // // // //                 });

// // // // // //                 setOpenFilter(null);
// // // // // //               }}
// // // // // //             >
// // // // // //               Limpar filtros
// // // // // //             </Button>

// // // // // //             <Button
// // // // // //               colorScheme="green"
// // // // // //               size="sm"
// // // // // //               onClick={() =>
// // // // // //                 exportGridToExcel(filtered, "Cadastro_fichas.xlsx")
// // // // // //               }
// // // // // //             >
// // // // // //               Exportar Excel
// // // // // //             </Button>
// // // // // //           </>
// // // // // //         }
// // // // // //       />
// // // // // //       {/* 
// // // // // //       <Flex
// // // // // //         justify="flex-end"
// // // // // //         mb={4}
// // // // // //       >

// // // // // //         <Button
// // // // // //           leftIcon={<FiX />}
// // // // // //           size="sm"
// // // // // //           variant="outline"
// // // // // //           colorScheme="red"
// // // // // //           onClick={() => {

// // // // // //             setFilters({
// // // // // //               nome: "",
// // // // // //               cpf: "",
// // // // // //               rg: "",
// // // // // //               titulo: "",
// // // // // //               sus: "",
// // // // // //               contato: "",

// // // // // //               nome_mae: "",
// // // // // //               data_nascimento: "",

// // // // // //               lideranca: "",
// // // // // //               zona: "",
// // // // // //               sessao: "",

// // // // // //               endereco: "",
// // // // // //               bairro: "",
// // // // // //               cidade: "",
// // // // // //               uf: "",

// // // // // //               observacao: ""
// // // // // //             });

// // // // // //             setOpenFilter(null);
// // // // // //           }}
// // // // // //         >
// // // // // //           Limpar filtros
// // // // // //         </Button>
// // // // // //       </Flex>

// // // // // //       <Flex
// // // // // //         justify="flex-end"
// // // // // //         mb={4}
// // // // // //       >

// // // // // //         <Button
// // // // // //           onClick={() => exportGridToExcel(filtered, "Cadastro_fichas.xlsx")}
// // // // // //         >
// // // // // //           Exportar Excel
// // // // // //         </Button>
// // // // // //       </Flex> */}

// // // // // //       <ContentCard>
// // // // // //         <DataTable
// // // // // //           columns={columns}
// // // // // //           data={filtered}
// // // // // //           progressPending={loading}
// // // // // //           pagination
// // // // // //           highlightOnHover
// // // // // //           responsive
// // // // // //           fixedHeader
// // // // // //           customStyles={customStyles}
// // // // // //         />
// // // // // //       </ContentCard>

// // // // // //       <FormModal
// // // // // //         isOpen={isOpen}
// // // // // //         onClose={onClose}
// // // // // //         initialData={editing}
// // // // // //         onSave={async (data: any) => {
// // // // // //           try {
// // // // // //             if (editing) {
// // // // // //               await FichaService.update(editing.id, data);
// // // // // //             } else {
// // // // // //               await FichaService.create(data);
// // // // // //             }

// // // // // //             toast({ title: "Salvo com sucesso", status: "success" });

// // // // // //             onClose();
// // // // // //             setEditing(null);
// // // // // //             loadData();
// // // // // //           } catch {
// // // // // //             toast({ title: "Erro ao salvar ficha", status: "error" });
// // // // // //           }
// // // // // //         }}
// // // // // //       />
// // // // // //     </Box>
// // // // // //   );
// // // // // // }


// // // // // import {
// // // // //   Box,
// // // // //   Flex,
// // // // //   IconButton,
// // // // //   Button,
// // // // //   Input,
// // // // //   Text,
// // // // //   Tooltip,
// // // // //   useDisclosure,
// // // // //   useToast,
// // // // // } from "@chakra-ui/react";

// // // // // import { FiEdit, FiPrinter, FiTrash2, FiSearch, FiX } from "react-icons/fi";

// // // // // import * as XLSX from "xlsx";
// // // // // import { saveAs } from "file-saver";

// // // // // import { useEffect, useMemo, useState } from "react";
// // // // // import DataTable from "react-data-table-component";

// // // // // import ContentCard from "../../components/common/ContentCard";
// // // // // import { PageHeader } from "../../components/common/PageHeader";
// // // // // import { FichaService } from "../../services/ficha.service";

// // // // // import FormModal from "./FormModal";

// // // // // export function exportGridToExcel(rows: any[], fileName = "Cadastro_fichas.xlsx") {
// // // // //   if (!rows?.length) return;

// // // // //   const keys = Object.keys(rows[0]);
// // // // //   const formatted = rows.map((row) =>
// // // // //     Object.fromEntries(
// // // // //       keys.map((key) => [
// // // // //         key,
// // // // //         row?.[key] == null
// // // // //           ? ""
// // // // //           : typeof row[key] === "object"
// // // // //           ? JSON.stringify(row[key])
// // // // //           : row[key],
// // // // //       ])
// // // // //     )
// // // // //   );

// // // // //   const worksheet = XLSX.utils.json_to_sheet(formatted);
// // // // //   const workbook = XLSX.utils.book_new();
// // // // //   XLSX.utils.book_append_sheet(workbook, worksheet, "Dados");

// // // // //   const buffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
// // // // //   saveAs(new Blob([buffer]), fileName);
// // // // // }

// // // // // export default function ListPage() {
// // // // //   const toast = useToast();
// // // // //   const { isOpen, onOpen, onClose } = useDisclosure();

// // // // //   const [rows, setRows] = useState<any[]>([]);
// // // // //   const [editing, setEditing] = useState<any>(null);
// // // // //   const [loading, setLoading] = useState(false);

// // // // //   const [filters, setFilters] = useState({
// // // // //     nome: "", cpf: "", rg: "", titulo: "", cartao_sus: "", contato: "",
// // // // //     nome_mae: "", data_nascimento: "", lideranca: "", zona: "", sessao: "",
// // // // //     endereco: "", bairro: "", cidade: "", uf: "", observacao: "",
// // // // //   });

// // // // //   const [openFilter, setOpenFilter] = useState<string | null>(null);

// // // // //   async function loadData() {
// // // // //     try {
// // // // //       setLoading(true);
// // // // //       const data = await FichaService.findAll();
// // // // //       setRows(data);
// // // // //     } catch {
// // // // //       toast({ title: "Erro ao carregar fichas", status: "error" });
// // // // //     } finally {
// // // // //       setLoading(false);
// // // // //     }
// // // // //   }

// // // // //   useEffect(() => {
// // // // //     loadData();
// // // // //   }, []);

// // // // //   async function handleDelete(id: number) {
// // // // //     if (!confirm("Deseja excluir esta ficha?")) return;

// // // // //     try {
// // // // //       await FichaService.delete(id);
// // // // //       toast({ title: "Ficha excluída com sucesso", status: "success" });
// // // // //       loadData();
// // // // //     } catch {
// // // // //       toast({ title: "Erro ao excluir ficha", status: "error" });
// // // // //     }
// // // // //   }

// // // // //   // ... (função handlePrint mantida igual - boa)

// // // // //   const filtered = useMemo(() => {
// // // // //     return rows.filter((item) => {
// // // // //       const check = (field: any, filter: string) =>
// // // // //         String(field ?? "").toLowerCase().includes(filter.toLowerCase());

// // // // //       return (
// // // // //         check(item.nome, filters.nome) &&
// // // // //         check(item.cpf, filters.cpf) &&
// // // // //         check(item.rg, filters.rg) &&
// // // // //         check(item.titulo, filters.titulo) &&
// // // // //         check(item.cartao_sus, filters.cartao_sus) &&
// // // // //         check(item.contato, filters.contato) &&
// // // // //         check(item.nome_mae, filters.nome_mae) &&
// // // // //         check(item.data_nascimento, filters.data_nascimento) &&
// // // // //         check(item.lideranca_nome, filters.lideranca) &&
// // // // //         check(item.zona_numero, filters.zona) &&
// // // // //         check(item.sessao_numero, filters.sessao) &&
// // // // //         check(item.endereco, filters.endereco) &&
// // // // //         check(item.bairro, filters.bairro) &&
// // // // //         check(item.cidade, filters.cidade) &&
// // // // //         check(item.uf, filters.uf) &&
// // // // //         check(item.observacao, filters.observacao)
// // // // //       );
// // // // //     });
// // // // //   }, [rows, filters]);

// // // // //   function renderFilter(field: keyof typeof filters, label: string) {
// // // // //     return openFilter === field ? (
// // // // //       <Input
// // // // //         size="sm"
// // // // //         autoFocus
// // // // //         placeholder={`Filtrar ${label}`}
// // // // //         value={filters[field]}
// // // // //         onChange={(e) => setFilters({ ...filters, [field]: e.target.value })}
// // // // //         onBlur={() => setOpenFilter(null)}
// // // // //       />
// // // // //     ) : (
// // // // //       <Flex align="center" gap={2}>
// // // // //         <Text fontSize="sm" fontWeight="600">{label}</Text>
// // // // //         <IconButton
// // // // //           aria-label="filtro"
// // // // //           icon={<FiSearch />}
// // // // //           size="xs"
// // // // //           variant="ghost"
// // // // //           onClick={() => setOpenFilter(field)}
// // // // //         />
// // // // //       </Flex>
// // // // //     );
// // // // //   }

// // // // //   const columns = [
// // // // //     { name: renderFilter("nome", "Nome"), selector: (r: any) => r.nome, minWidth: "180px", wrap: true },
// // // // //     { name: renderFilter("cpf", "CPF"), selector: (r: any) => r.cpf, minWidth: "140px" },
// // // // //     { name: renderFilter("rg", "RG"), selector: (r: any) => r.rg, minWidth: "120px" },
// // // // //     { name: renderFilter("titulo", "Título"), selector: (r: any) => r.titulo, minWidth: "130px" },
// // // // //     { name: renderFilter("cartao_sus", "SUS"), selector: (r: any) => r.cartao_sus, minWidth: "140px" },
// // // // //     { name: renderFilter("data_nascimento", "Nascimento"), selector: (r: any) => r.data_nascimento, minWidth: "130px" },
// // // // //     { name: renderFilter("nome_mae", "Mãe"), selector: (r: any) => r.nome_mae, minWidth: "160px", wrap: true },
// // // // //     { name: renderFilter("contato", "Contato"), selector: (r: any) => r.contato, minWidth: "160px", wrap: true },
// // // // //     { name: renderFilter("lideranca", "Liderança"), selector: (r: any) => r.lideranca_nome, minWidth: "170px", wrap: true },
// // // // //     { name: renderFilter("zona", "Zona"), selector: (r: any) => r.zona_numero, minWidth: "100px" },
// // // // //     { name: renderFilter("sessao", "Sessão"), selector: (r: any) => r.sessao_numero, minWidth: "120px" },
// // // // //     { name: renderFilter("endereco", "Endereço"), selector: (r: any) => r.endereco, minWidth: "180px", wrap: true },
// // // // //     { name: renderFilter("bairro", "Bairro"), selector: (r: any) => r.bairro, minWidth: "140px", wrap: true },
// // // // //     { name: renderFilter("cidade", "Cidade"), selector: (r: any) => r.cidade, minWidth: "140px", wrap: true },
// // // // //     { name: renderFilter("uf", "UF"), selector: (r: any) => r.uf, minWidth: "80px" },
// // // // //     { name: renderFilter("observacao", "Observação"), selector: (r: any) => r.observacao, minWidth: "180px", wrap: true },

// // // // //     {
// // // // //       name: "Ações",
// // // // //       width: "160px",
// // // // //       cell: (row: any) => (
// // // // //         <Flex gap={2}>
// // // // //           <IconButton icon={<FiEdit />} size="sm" colorScheme="blue" onClick={() => { setEditing(row); onOpen(); }} />
// // // // //           <IconButton icon={<FiTrash2 />} size="sm" colorScheme="red" onClick={() => handleDelete(row.id)} />
// // // // //           <Tooltip label="Imprimir">
// // // // //             <IconButton icon={<FiPrinter />} size="sm" colorScheme="green" onClick={() => handlePrint(row)} />
// // // // //           </Tooltip>
// // // // //         </Flex>
// // // // //       ),
// // // // //     },
// // // // //   ];

// // // // //   return (
// // // // //     <Box>
// // // // //       <PageHeader
// // // // //         title="Fichas"
// // // // //         onNew={() => { setEditing(null); onOpen(); }}
// // // // //         actions={
// // // // //           <>
// // // // //             <Button
// // // // //               size="sm"
// // // // //               variant="outline"
// // // // //               colorScheme="red"
// // // // //               leftIcon={<FiX />}
// // // // //               onClick={() => {
// // // // //                 setFilters({ ...filters, ...Object.keys(filters).reduce((a, k) => ({ ...a, [k]: "" }), {}) });
// // // // //                 setOpenFilter(null);
// // // // //               }}
// // // // //             >
// // // // //               Limpar filtros
// // // // //             </Button>

// // // // //             <Button colorScheme="green" size="sm" onClick={() => exportGridToExcel(filtered)}>
// // // // //               Exportar Excel
// // // // //             </Button>
// // // // //           </>
// // // // //         }
// // // // //       />

// // // // //       <ContentCard>
// // // // //         <DataTable
// // // // //           columns={columns}
// // // // //           data={filtered}
// // // // //           pagination
// // // // //           highlightOnHover
// // // // //           responsive
// // // // //           fixedHeader
// // // // //           progressPending={loading}
// // // // //           noDataComponent="Nenhum registro encontrado"
// // // // //           customStyles={{
// // // // //             headCells: { style: { fontWeight: "bold", fontSize: "13px", backgroundColor: "#f8fafc" } },
// // // // //             cells: { style: { fontSize: "13px", whiteSpace: "normal", wordBreak: "break-word" } },
// // // // //           }}
// // // // //         />
// // // // //       </ContentCard>

// // // // //       <FormModal
// // // // //         isOpen={isOpen}
// // // // //         onClose={onClose}
// // // // //         initialData={editing}
// // // // //         onSave={async (data: any) => {
// // // // //           try {
// // // // //             if (editing) {
// // // // //               await FichaService.update(editing.id, data);
// // // // //             } else {
// // // // //               await FichaService.create(data);
// // // // //             }
// // // // //             toast({ title: "Salvo com sucesso!", status: "success" });
// // // // //             loadData();
// // // // //           } catch {
// // // // //             toast({ title: "Erro ao salvar ficha", status: "error" });
// // // // //           } finally {
// // // // //             onClose();
// // // // //             setEditing(null);
// // // // //           }
// // // // //         }}
// // // // //       />
// // // // //     </Box>
// // // // //   );
// // // // // }

// // // // import {
// // // //   Box,
// // // //   Flex,
// // // //   IconButton,
// // // //   Button,
// // // //   Text,
// // // //   Tooltip,
// // // //   useDisclosure,
// // // //   useToast,
// // // //   SimpleGrid,
// // // //   Stat,
// // // //   StatLabel,
// // // //   StatNumber,
// // // //   StatGroup,
// // // // } from "@chakra-ui/react";

// // // // import { FiEdit, FiPrinter, FiTrash2, FiSearch, FiX } from "react-icons/fi";

// // // // import * as XLSX from "xlsx";
// // // // import { saveAs } from "file-saver";

// // // // import { useEffect, useMemo, useState } from "react";
// // // // import DataTable from "react-data-table-component";

// // // // import ContentCard from "../../components/common/ContentCard";
// // // // import { PageHeader } from "../../components/common/PageHeader";
// // // // import { FichaService } from "../../services/ficha.service";

// // // // import FormModal from "./FormModal";

// // // // export function exportGridToExcel(rows: any[], fileName = "Cadastro_fichas.xlsx") {
// // // //   if (!rows?.length) return;

// // // //   const keys = Object.keys(rows[0]);
// // // //   const formatted = rows.map((row) =>
// // // //     Object.fromEntries(
// // // //       keys.map((key) => [
// // // //         key,
// // // //         row?.[key] == null ? "" : typeof row[key] === "object" ? JSON.stringify(row[key]) : row[key],
// // // //       ])
// // // //     )
// // // //   );

// // // //   const worksheet = XLSX.utils.json_to_sheet(formatted);
// // // //   const workbook = XLSX.utils.book_new();
// // // //   XLSX.utils.book_append_sheet(workbook, worksheet, "Dados");

// // // //   const buffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
// // // //   saveAs(new Blob([buffer]), fileName);
// // // // }

// // // // export default function ListPage() {
// // // //   const toast = useToast();
// // // //   const { isOpen, onOpen, onClose } = useDisclosure();

// // // //   const [rows, setRows] = useState<any[]>([]);
// // // //   const [editing, setEditing] = useState<any>(null);
// // // //   const [loading, setLoading] = useState(false);

// // // //   const [filters, setFilters] = useState({
// // // //     nome: "", cpf: "", rg: "", titulo: "", cartao_sus: "", contato: "",
// // // //     nome_mae: "", data_nascimento: "", lideranca: "", zona: "", sessao: "",
// // // //     endereco: "", bairro: "", cidade: "", uf: "", observacao: "",
// // // //   });

// // // //   const [openFilter, setOpenFilter] = useState<string | null>(null);

// // // //   async function loadData() {
// // // //     try {
// // // //       setLoading(true);
// // // //       const data = await FichaService.findAll();
// // // //       setRows(data);
// // // //     } catch {
// // // //       toast({ title: "Erro ao carregar fichas", status: "error" });
// // // //     } finally {
// // // //       setLoading(false);
// // // //     }
// // // //   }

// // // //   useEffect(() => {
// // // //     loadData();
// // // //   }, []);

// // // //   async function handleDelete(id: number) {
// // // //     if (!confirm("Deseja excluir esta ficha?")) return;

// // // //     try {
// // // //       await FichaService.delete(id);
// // // //       toast({ title: "Ficha excluída com sucesso", status: "success" });
// // // //       loadData();
// // // //     } catch {
// // // //       toast({ title: "Erro ao excluir ficha", status: "error" });
// // // //     }
// // // //   }

// // // //   // Função handlePrint (mantida - assumindo que está definida acima)
// // // //   // function handlePrint(ficha: any) { ... }

// // // //   const filtered = useMemo(() => {
// // // //     return rows.filter((item) => {
// // // //       const check = (field: any, filter: string) =>
// // // //         String(field ?? "").toLowerCase().includes(filter.toLowerCase());

// // // //       return (
// // // //         check(item.nome, filters.nome) &&
// // // //         check(item.cpf, filters.cpf) &&
// // // //         check(item.rg, filters.rg) &&
// // // //         check(item.titulo, filters.titulo) &&
// // // //         check(item.cartao_sus, filters.cartao_sus) &&
// // // //         check(item.contato, filters.contato) &&
// // // //         check(item.nome_mae, filters.nome_mae) &&
// // // //         check(item.data_nascimento, filters.data_nascimento) &&
// // // //         check(item.lideranca_nome, filters.lideranca) &&
// // // //         check(item.zona_numero, filters.zona) &&
// // // //         check(item.sessao_numero, filters.sessao) &&
// // // //         check(item.endereco, filters.endereco) &&
// // // //         check(item.bairro, filters.bairro) &&
// // // //         check(item.cidade, filters.cidade) &&
// // // //         check(item.uf, filters.uf) &&
// // // //         check(item.observacao, filters.observacao)
// // // //       );
// // // //     });
// // // //   }, [rows, filters]);

// // // //   function renderFilter(field: keyof typeof filters, label: string) {
// // // //     return openFilter === field ? (
// // // //       <Input
// // // //         size="sm"
// // // //         autoFocus
// // // //         placeholder={`Filtrar ${label}`}
// // // //         value={filters[field]}
// // // //         onChange={(e) => setFilters({ ...filters, [field]: e.target.value })}
// // // //         onBlur={() => setOpenFilter(null)}
// // // //       />
// // // //     ) : (
// // // //       <Flex align="center" gap={2}>
// // // //         <Text fontSize="sm" fontWeight="600">{label}</Text>
// // // //         <IconButton
// // // //           aria-label="filtro"
// // // //           icon={<FiSearch />}
// // // //           size="xs"
// // // //           variant="ghost"
// // // //           onClick={() => setOpenFilter(field)}
// // // //         />
// // // //       </Flex>
// // // //     );
// // // //   }

// // // //   const columns = [
// // // //     { name: renderFilter("nome", "Nome"), selector: (r: any) => r.nome, minWidth: "180px", wrap: true },
// // // //     { name: renderFilter("cpf", "CPF"), selector: (r: any) => r.cpf, minWidth: "140px" },
// // // //     { name: renderFilter("rg", "RG"), selector: (r: any) => r.rg, minWidth: "120px" },
// // // //     { name: renderFilter("titulo", "Título"), selector: (r: any) => r.titulo, minWidth: "130px" },
// // // //     { name: renderFilter("cartao_sus", "SUS"), selector: (r: any) => r.cartao_sus, minWidth: "140px" },
// // // //     { name: renderFilter("data_nascimento", "Nascimento"), selector: (r: any) => r.data_nascimento, minWidth: "130px" },
// // // //     { name: renderFilter("nome_mae", "Mãe"), selector: (r: any) => r.nome_mae, minWidth: "160px", wrap: true },
// // // //     { name: renderFilter("contato", "Contato"), selector: (r: any) => r.contato, minWidth: "160px", wrap: true },

// // // //     {
// // // //       name: renderFilter("lideranca", "Liderança"),
// // // //       selector: (r: any) => `${r.numero_lideranca || ""} - ${r.lideranca_nome || ""}`,
// // // //       minWidth: "180px",
// // // //       wrap: true,
// // // //     },
// // // //     {
// // // //       name: renderFilter("zona", "Zona"),
// // // //       selector: (r: any) => `${r.zona_numero || ""} - ${r.zona_descricao || ""}`,
// // // //       minWidth: "160px",
// // // //       wrap: true,
// // // //     },
// // // //     {
// // // //       name: renderFilter("sessao", "Sessão"),
// // // //       selector: (r: any) => `${r.sessao_numero || ""} - ${r.sessao_descricao || ""}`,
// // // //       minWidth: "160px",
// // // //       wrap: true,
// // // //     },

// // // //     { name: renderFilter("endereco", "Endereço"), selector: (r: any) => r.endereco, minWidth: "180px", wrap: true },
// // // //     { name: renderFilter("bairro", "Bairro"), selector: (r: any) => r.bairro, minWidth: "140px", wrap: true },
// // // //     { name: renderFilter("cidade", "Cidade"), selector: (r: any) => r.cidade, minWidth: "140px", wrap: true },
// // // //     { name: renderFilter("uf", "UF"), selector: (r: any) => r.uf, minWidth: "80px" },
// // // //     { name: renderFilter("observacao", "Observação"), selector: (r: any) => r.observacao, minWidth: "180px", wrap: true },

// // // //     {
// // // //       name: "Ações",
// // // //       width: "160px",
// // // //       cell: (row: any) => (
// // // //         <Flex gap={2}>
// // // //           <IconButton icon={<FiEdit />} size="sm" colorScheme="blue" onClick={() => { setEditing(row); onOpen(); }} />
// // // //           <IconButton icon={<FiTrash2 />} size="sm" colorScheme="red" onClick={() => handleDelete(row.id)} />
// // // //           <Tooltip label="Imprimir">
// // // //             <IconButton icon={<FiPrinter />} size="sm" colorScheme="green" onClick={() => handlePrint(row)} />
// // // //           </Tooltip>
// // // //         </Flex>
// // // //       ),
// // // //     },
// // // //   ];

// // // //   return (
// // // //     <Box>
// // // //       <PageHeader
// // // //         title="Fichas"
// // // //         onNew={() => { setEditing(null); onOpen(); }}
// // // //         actions={
// // // //           <>
// // // //             <Button
// // // //               size="sm"
// // // //               variant="outline"
// // // //               colorScheme="red"
// // // //               leftIcon={<FiX />}
// // // //               onClick={() => {
// // // //                 setFilters({
// // // //                   nome: "", cpf: "", rg: "", titulo: "", cartao_sus: "", contato: "",
// // // //                   nome_mae: "", data_nascimento: "", lideranca: "", zona: "", sessao: "",
// // // //                   endereco: "", bairro: "", cidade: "", uf: "", observacao: "",
// // // //                 });
// // // //                 setOpenFilter(null);
// // // //               }}
// // // //             >
// // // //               Limpar filtros
// // // //             </Button>

// // // //             <Button colorScheme="green" size="sm" onClick={() => exportGridToExcel(filtered)}>
// // // //               Exportar Excel
// // // //             </Button>
// // // //           </>
// // // //         }
// // // //       />

// // // //       {/* Card de Total de Registros */}
// // // //       <ContentCard mb={4}>
// // // //         <StatGroup>
// // // //           <Stat>
// // // //             <StatLabel>Total de Registros</StatLabel>
// // // //             <StatNumber fontSize="2xl" color="blue.600">
// // // //               {filtered.length}
// // // //             </StatNumber>
// // // //           </Stat>
// // // //         </StatGroup>
// // // //       </ContentCard>

// // // //       <ContentCard>
// // // //         <DataTable
// // // //           columns={columns}
// // // //           data={filtered}
// // // //           pagination
// // // //           highlightOnHover
// // // //           responsive
// // // //           fixedHeader
// // // //           progressPending={loading}
// // // //           noDataComponent="Nenhum registro encontrado"
// // // //           paginationComponentOptions={{
// // // //             rowsPerPageText: "Registros por página",
// // // //             rangeSeparatorText: "de",
// // // //             selectAllRowsItemText: "Todos",
// // // //             selectAllRowsItem: true,
// // // //           }}
// // // //           customStyles={{
// // // //             headCells: { style: { fontWeight: "bold", fontSize: "13px", backgroundColor: "#f8fafc" } },
// // // //             cells: { style: { fontSize: "13px", whiteSpace: "normal", wordBreak: "break-word" } },
// // // //           }}
// // // //         />
// // // //       </ContentCard>

// // // //       <FormModal
// // // //         isOpen={isOpen}
// // // //         onClose={onClose}
// // // //         initialData={editing}
// // // //         onSave={async (data: any) => {
// // // //           try {
// // // //             if (editing) {
// // // //               await FichaService.update(editing.id, data);
// // // //             } else {
// // // //               await FichaService.create(data);
// // // //             }
// // // //             toast({ title: "Salvo com sucesso!", status: "success" });
// // // //             loadData();
// // // //           } catch {
// // // //             toast({ title: "Erro ao salvar ficha", status: "error" });
// // // //           } finally {
// // // //             onClose();
// // // //             setEditing(null);
// // // //           }
// // // //         }}
// // // //       />
// // // //     </Box>
// // // //   );
// // // // }

// // // import {
// // //   Box,
// // //   Flex,
// // //   IconButton,
// // //   Button,
// // //   Input,
// // //   Text,
// // //   Tooltip,
// // //   useDisclosure,
// // //   useToast,
// // //   Stat,
// // //   StatLabel,
// // //   StatNumber,
// // //   StatGroup,
// // // } from "@chakra-ui/react";

// // // import { FiEdit, FiPrinter, FiTrash2, FiSearch, FiX } from "react-icons/fi";

// // // import * as XLSX from "xlsx";
// // // import { saveAs } from "file-saver";

// // // import { useEffect, useMemo, useState } from "react";
// // // import DataTable from "react-data-table-component";

// // // import ContentCard from "../../components/common/ContentCard";
// // // import { PageHeader } from "../../components/common/PageHeader";
// // // import { FichaService } from "../../services/ficha.service";

// // // import FormModal from "./FormModal";

// // // export function exportGridToExcel(rows: any[], fileName = "Cadastro_fichas.xlsx") {
// // //   if (!rows?.length) return;

// // //   const keys = Object.keys(rows[0]);
// // //   const formatted = rows.map((row) =>
// // //     Object.fromEntries(
// // //       keys.map((key) => [
// // //         key,
// // //         row?.[key] == null ? "" : typeof row[key] === "object" ? JSON.stringify(row[key]) : row[key],
// // //       ])
// // //     )
// // //   );

// // //   const worksheet = XLSX.utils.json_to_sheet(formatted);
// // //   const workbook = XLSX.utils.book_new();
// // //   XLSX.utils.book_append_sheet(workbook, worksheet, "Dados");

// // //   const buffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
// // //   saveAs(new Blob([buffer]), fileName);
// // // }

// // // export default function ListPage() {
// // //   const toast = useToast();
// // //   const { isOpen, onOpen, onClose } = useDisclosure();

// // //   const [rows, setRows] = useState<any[]>([]);
// // //   const [editing, setEditing] = useState<any>(null);
// // //   const [loading, setLoading] = useState(false);

// // //   const [filters, setFilters] = useState({
// // //     nome: "", cpf: "", rg: "", titulo: "", cartao_sus: "", contato: "",
// // //     nome_mae: "", data_nascimento: "", lideranca: "", zona: "", sessao: "",
// // //     endereco: "", bairro: "", cidade: "", uf: "", observacao: "",
// // //   });

// // //   const [openFilter, setOpenFilter] = useState<string | null>(null);

// // //   async function loadData() {
// // //     try {
// // //       setLoading(true);
// // //       const data = await FichaService.findAll();
// // //       setRows(data);
// // //     } catch {
// // //       toast({ title: "Erro ao carregar fichas", status: "error" });
// // //     } finally {
// // //       setLoading(false);
// // //     }
// // //   }

// // //   useEffect(() => {
// // //     loadData();
// // //   }, []);

// // //   async function handleDelete(id: number) {
// // //     if (!confirm("Deseja excluir esta ficha?")) return;

// // //     try {
// // //       await FichaService.delete(id);
// // //       toast({ title: "Ficha excluída com sucesso", status: "success" });
// // //       loadData();
// // //     } catch {
// // //       toast({ title: "Erro ao excluir ficha", status: "error" });
// // //     }
// // //   }

// // //   const filtered = useMemo(() => {
// // //     return rows.filter((item) => {
// // //       const check = (field: any, filter: string) =>
// // //         String(field ?? "").toLowerCase().includes(filter.toLowerCase());

// // //       return (
// // //         check(item.nome, filters.nome) &&
// // //         check(item.cpf, filters.cpf) &&
// // //         check(item.rg, filters.rg) &&
// // //         check(item.titulo, filters.titulo) &&
// // //         check(item.cartao_sus, filters.cartao_sus) &&
// // //         check(item.contato, filters.contato) &&
// // //         check(item.nome_mae, filters.nome_mae) &&
// // //         check(item.data_nascimento, filters.data_nascimento) &&
// // //         check(item.lideranca_nome, filters.lideranca) &&
// // //         check(item.zona_numero, filters.zona) &&
// // //         check(item.sessao_numero, filters.sessao) &&
// // //         check(item.endereco, filters.endereco) &&
// // //         check(item.bairro, filters.bairro) &&
// // //         check(item.cidade, filters.cidade) &&
// // //         check(item.uf, filters.uf) &&
// // //         check(item.observacao, filters.observacao)
// // //       );
// // //     });
// // //   }, [rows, filters]);

// // //   function renderFilter(field: keyof typeof filters, label: string) {
// // //     return openFilter === field ? (
// // //       <Input
// // //         size="sm"
// // //         autoFocus
// // //         placeholder={`Filtrar ${label}`}
// // //         value={filters[field]}
// // //         onChange={(e) => setFilters({ ...filters, [field]: e.target.value })}
// // //         onBlur={() => setOpenFilter(null)}
// // //       />
// // //     ) : (
// // //       <Flex align="center" gap={2}>
// // //         <Text fontSize="sm" fontWeight="600">{label}</Text>
// // //         <IconButton
// // //           aria-label="filtro"
// // //           icon={<FiSearch />}
// // //           size="xs"
// // //           variant="ghost"
// // //           onClick={() => setOpenFilter(field)}
// // //         />
// // //       </Flex>
// // //     );
// // //   }

// // //   const columns = [
// // //     { name: renderFilter("nome", "Nome"), selector: (r: any) => r.nome, minWidth: "180px", wrap: true },
// // //     { name: renderFilter("cpf", "CPF"), selector: (r: any) => r.cpf, minWidth: "140px" },
// // //     { name: renderFilter("rg", "RG"), selector: (r: any) => r.rg, minWidth: "120px" },
// // //     { name: renderFilter("titulo", "Título"), selector: (r: any) => r.titulo, minWidth: "130px" },
// // //     { name: renderFilter("cartao_sus", "SUS"), selector: (r: any) => r.cartao_sus, minWidth: "140px" },
// // //     { name: renderFilter("data_nascimento", "Nascimento"), selector: (r: any) => r.data_nascimento, minWidth: "130px" },
// // //     { name: renderFilter("nome_mae", "Mãe"), selector: (r: any) => r.nome_mae, minWidth: "160px", wrap: true },
// // //     { name: renderFilter("contato", "Contato"), selector: (r: any) => r.contato, minWidth: "160px", wrap: true },

// // //     {
// // //       name: renderFilter("lideranca", "Liderança"),
// // //       selector: (r: any) => `${r.numero_lideranca || ""} - ${r.lideranca_nome || ""}`,
// // //       minWidth: "180px",
// // //       wrap: true,
// // //     },
// // //     {
// // //       name: renderFilter("zona", "Zona"),
// // //       selector: (r: any) => `${r.zona_numero || ""} - ${r.zona_descricao || r.zona_nome || ""}`,
// // //       minWidth: "160px",
// // //       wrap: true,
// // //     },
// // //     {
// // //       name: renderFilter("sessao", "Sessão"),
// // //       selector: (r: any) => `${r.sessao_numero || ""} - ${r.sessao_descricao || ""}`,
// // //       minWidth: "160px",
// // //       wrap: true,
// // //     },

// // //     { name: renderFilter("endereco", "Endereço"), selector: (r: any) => r.endereco, minWidth: "180px", wrap: true },
// // //     { name: renderFilter("bairro", "Bairro"), selector: (r: any) => r.bairro, minWidth: "140px", wrap: true },
// // //     { name: renderFilter("cidade", "Cidade"), selector: (r: any) => r.cidade, minWidth: "140px", wrap: true },
// // //     { name: renderFilter("uf", "UF"), selector: (r: any) => r.uf, minWidth: "80px" },
// // //     { name: renderFilter("observacao", "Observação"), selector: (r: any) => r.observacao, minWidth: "180px", wrap: true },

// // //     {
// // //       name: "Ações",
// // //       width: "160px",
// // //       cell: (row: any) => (
// // //         <Flex gap={2}>
// // //           <IconButton icon={<FiEdit />} size="sm" colorScheme="blue" onClick={() => { setEditing(row); onOpen(); }} />
// // //           <IconButton icon={<FiTrash2 />} size="sm" colorScheme="red" onClick={() => handleDelete(row.id)} />
// // //           <Tooltip label="Imprimir">
// // //             <IconButton icon={<FiPrinter />} size="sm" colorScheme="green" onClick={() => handlePrint(row)} />
// // //           </Tooltip>
// // //         </Flex>
// // //       ),
// // //     },
// // //   ];

// // //   return (
// // //     <Box>
// // //       <PageHeader
// // //         title="Fichas"
// // //         onNew={() => { setEditing(null); onOpen(); }}
// // //         actions={
// // //           <>
// // //             <Button
// // //               size="sm"
// // //               variant="outline"
// // //               colorScheme="red"
// // //               leftIcon={<FiX />}
// // //               onClick={() => {
// // //                 setFilters({
// // //                   nome: "", cpf: "", rg: "", titulo: "", cartao_sus: "", contato: "",
// // //                   nome_mae: "", data_nascimento: "", lideranca: "", zona: "", sessao: "",
// // //                   endereco: "", bairro: "", cidade: "", uf: "", observacao: "",
// // //                 });
// // //                 setOpenFilter(null);
// // //               }}
// // //             >
// // //               Limpar filtros
// // //             </Button>

// // //             <Button colorScheme="green" size="sm" onClick={() => exportGridToExcel(filtered)}>
// // //               Exportar Excel
// // //             </Button>
// // //           </>
// // //         }
// // //       />

// // //       {/* Card Total de Registros */}
// // //       <ContentCard mb={4}>
// // //         <StatGroup>
// // //           <Stat>
// // //             <StatLabel>Total de Registros Encontrados</StatLabel>
// // //             <StatNumber fontSize="2.2xl" color="blue.600">
// // //               {filtered.length}
// // //             </StatNumber>
// // //           </Stat>
// // //         </StatGroup>
// // //       </ContentCard>

// // //       <ContentCard>
// // //         <DataTable
// // //           columns={columns}
// // //           data={filtered}
// // //           pagination
// // //           highlightOnHover
// // //           responsive
// // //           fixedHeader
// // //           progressPending={loading}
// // //           noDataComponent="Nenhum registro encontrado"
// // //           paginationComponentOptions={{
// // //             rowsPerPageText: "Registros por página:",
// // //             rangeSeparatorText: "de",
// // //             selectAllRowsItemText: "Todos",
// // //           }}
// // //           customStyles={{
// // //             headCells: { style: { fontWeight: "bold", fontSize: "13px", backgroundColor: "#f8fafc" } },
// // //             cells: { style: { fontSize: "13px", whiteSpace: "normal", wordBreak: "break-word" } },
// // //           }}
// // //         />
// // //       </ContentCard>

// // //       <FormModal
// // //         isOpen={isOpen}
// // //         onClose={onClose}
// // //         initialData={editing}
// // //         onSave={async (data: any) => {
// // //           try {
// // //             if (editing) {
// // //               await FichaService.update(editing.id, data);
// // //             } else {
// // //               await FichaService.create(data);
// // //             }
// // //             toast({ title: "Salvo com sucesso!", status: "success" });
// // //             loadData();
// // //           } catch {
// // //             toast({ title: "Erro ao salvar ficha", status: "error" });
// // //           } finally {
// // //             onClose();
// // //             setEditing(null);
// // //           }
// // //         }}
// // //       />
// // //     </Box>
// // //   );
// // // }

// // import {
// //   Box,
// //   Flex,
// //   IconButton,
// //   Button,
// //   Input,
// //   Text,
// //   Tooltip,
// //   useDisclosure,
// //   useToast,
// // } from "@chakra-ui/react";

// // import { FiEdit, FiPrinter, FiTrash2, FiSearch, FiX } from "react-icons/fi";

// // import * as XLSX from "xlsx";
// // import { saveAs } from "file-saver";

// // import { useEffect, useMemo, useState } from "react";
// // import DataTable from "react-data-table-component";

// // import ContentCard from "../../components/common/ContentCard";
// // import { PageHeader } from "../../components/common/PageHeader";
// // import { FichaService } from "../../services/ficha.service";

// // import FormModal from "./FormModal";

// // export function exportGridToExcel(rows: any[], fileName = "Cadastro_fichas.xlsx") {
// //   if (!rows?.length) return;

// //   const keys = Object.keys(rows[0]);
// //   const formatted = rows.map((row) =>
// //     Object.fromEntries(
// //       keys.map((key) => [
// //         key,
// //         row?.[key] == null ? "" : typeof row[key] === "object" ? JSON.stringify(row[key]) : row[key],
// //       ])
// //     )
// //   );

// //   const worksheet = XLSX.utils.json_to_sheet(formatted);
// //   const workbook = XLSX.utils.book_new();
// //   XLSX.utils.book_append_sheet(workbook, worksheet, "Dados");

// //   const buffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
// //   saveAs(new Blob([buffer]), fileName);
// // }

// // export default function ListPage() {
// //   const toast = useToast();
// //   const { isOpen, onOpen, onClose } = useDisclosure();

// //   const [rows, setRows] = useState<any[]>([]);
// //   const [editing, setEditing] = useState<any>(null);
// //   const [loading, setLoading] = useState(false);

// //   const [filters, setFilters] = useState({
// //     nome: "", cpf: "", rg: "", titulo: "", cartao_sus: "", contato: "",
// //     nome_mae: "", data_nascimento: "", lideranca: "", zona: "", sessao: "",
// //     endereco: "", bairro: "", cidade: "", uf: "", observacao: "",
// //   });

// //   const [openFilter, setOpenFilter] = useState<string | null>(null);

// //   async function loadData() {
// //     try {
// //       setLoading(true);
// //       const data = await FichaService.findAll();
// //       setRows(data);
// //     } catch {
// //       toast({ title: "Erro ao carregar fichas", status: "error" });
// //     } finally {
// //       setLoading(false);
// //     }
// //   }

// //   useEffect(() => {
// //     loadData();
// //   }, []);

// //   async function handleDelete(id: number) {
// //     if (!confirm("Deseja excluir esta ficha?")) return;

// //     try {
// //       await FichaService.delete(id);
// //       toast({ title: "Ficha excluída com sucesso", status: "success" });
// //       loadData();
// //     } catch {
// //       toast({ title: "Erro ao excluir ficha", status: "error" });
// //     }
// //   }

// //   const filtered = useMemo(() => {
// //     return rows.filter((item) => {
// //       const check = (field: any, filter: string) =>
// //         String(field ?? "").toLowerCase().includes(filter.toLowerCase());

// //       return (
// //         check(item.nome, filters.nome) &&
// //         check(item.cpf, filters.cpf) &&
// //         check(item.rg, filters.rg) &&
// //         check(item.titulo, filters.titulo) &&
// //         check(item.cartao_sus, filters.cartao_sus) &&
// //         check(item.contato, filters.contato) &&
// //         check(item.nome_mae, filters.nome_mae) &&
// //         check(item.data_nascimento, filters.data_nascimento) &&
// //         check(item.lideranca_nome, filters.lideranca) &&
// //         check(item.zona_numero, filters.zona) &&
// //         check(item.sessao_numero, filters.sessao) &&
// //         check(item.endereco, filters.endereco) &&
// //         check(item.bairro, filters.bairro) &&
// //         check(item.cidade, filters.cidade) &&
// //         check(item.uf, filters.uf) &&
// //         check(item.observacao, filters.observacao)
// //       );
// //     });
// //   }, [rows, filters]);

// //   function renderFilter(field: keyof typeof filters, label: string) {
// //     return openFilter === field ? (
// //       <Input
// //         size="sm"
// //         autoFocus
// //         placeholder={`Filtrar ${label}`}
// //         value={filters[field]}
// //         onChange={(e) => setFilters({ ...filters, [field]: e.target.value })}
// //         onBlur={() => setOpenFilter(null)}
// //       />
// //     ) : (
// //       <Flex align="center" gap={2}>
// //         <Text fontSize="sm" fontWeight="600">{label}</Text>
// //         <IconButton
// //           aria-label="filtro"
// //           icon={<FiSearch />}
// //           size="xs"
// //           variant="ghost"
// //           onClick={() => setOpenFilter(field)}
// //         />
// //       </Flex>
// //     );
// //   }

// //   const columns = [
// //     { name: renderFilter("nome", "Nome"), selector: (r: any) => r.nome, minWidth: "180px", wrap: true },
// //     { name: renderFilter("cpf", "CPF"), selector: (r: any) => r.cpf, minWidth: "140px" },
// //     { name: renderFilter("rg", "RG"), selector: (r: any) => r.rg, minWidth: "120px" },
// //     { name: renderFilter("titulo", "Título"), selector: (r: any) => r.titulo, minWidth: "130px" },
// //     { name: renderFilter("cartao_sus", "SUS"), selector: (r: any) => r.cartao_sus, minWidth: "140px" },
// //     { name: renderFilter("data_nascimento", "Nascimento"), selector: (r: any) => r.data_nascimento, minWidth: "130px" },
// //     { name: renderFilter("nome_mae", "Mãe"), selector: (r: any) => r.nome_mae, minWidth: "160px", wrap: true },
// //     { name: renderFilter("contato", "Contato"), selector: (r: any) => r.contato, minWidth: "160px", wrap: true },

// //     {
// //       name: renderFilter("lideranca", "Liderança"),
// //       selector: (r: any) => `${r.numero_lideranca || ""} - ${r.lideranca_nome || ""}`,
// //       minWidth: "180px",
// //       wrap: true,
// //     },
// //     {
// //       name: renderFilter("zona", "Zona"),
// //       selector: (r: any) => `${r.zona_numero || ""} - ${r.zona_descricao || ""}`,
// //       minWidth: "160px",
// //       wrap: true,
// //     },
// //     {
// //       name: renderFilter("sessao", "Sessão"),
// //       selector: (r: any) => `${r.sessao_numero || ""} - ${r.sessao_descricao || ""}`,
// //       minWidth: "160px",
// //       wrap: true,
// //     },

// //     { name: renderFilter("endereco", "Endereço"), selector: (r: any) => r.endereco, minWidth: "180px", wrap: true },
// //     { name: renderFilter("bairro", "Bairro"), selector: (r: any) => r.bairro, minWidth: "140px", wrap: true },
// //     { name: renderFilter("cidade", "Cidade"), selector: (r: any) => r.cidade, minWidth: "140px", wrap: true },
// //     { name: renderFilter("uf", "UF"), selector: (r: any) => r.uf, minWidth: "80px" },
// //     { name: renderFilter("observacao", "Observação"), selector: (r: any) => r.observacao, minWidth: "180px", wrap: true },

// //     {
// //       name: "Ações",
// //       width: "160px",
// //       cell: (row: any) => (
// //         <Flex gap={2}>
// //           <IconButton icon={<FiEdit />} size="sm" colorScheme="blue" onClick={() => { setEditing(row); onOpen(); }} />
// //           <IconButton icon={<FiTrash2 />} size="sm" colorScheme="red" onClick={() => handleDelete(row.id)} />
// //           <Tooltip label="Imprimir">
// //             <IconButton icon={<FiPrinter />} size="sm" colorScheme="green" onClick={() => handlePrint(row)} />
// //           </Tooltip>
// //         </Flex>
// //       ),
// //     },
// //   ];

// //   return (
// //     <Box>
// //       <PageHeader
// //         title="Fichas"
// //         onNew={() => { setEditing(null); onOpen(); }}
// //         actions={
// //           <>
// //             <Button
// //               size="sm"
// //               variant="outline"
// //               colorScheme="red"
// //               leftIcon={<FiX />}
// //               onClick={() => {
// //                 setFilters({
// //                   nome: "", cpf: "", rg: "", titulo: "", cartao_sus: "", contato: "",
// //                   nome_mae: "", data_nascimento: "", lideranca: "", zona: "", sessao: "",
// //                   endereco: "", bairro: "", cidade: "", uf: "", observacao: "",
// //                 });
// //                 setOpenFilter(null);
// //               }}
// //             >
// //               Limpar filtros
// //             </Button>

// //             <Button colorScheme="green" size="sm" onClick={() => exportGridToExcel(filtered)}>
// //               Exportar Excel
// //             </Button>
// //           </>
// //         }
// //       />

// //       {/* Card Total de Registros - Melhorado */}
// //       <ContentCard mb={6}>
// //         <Box p={5} bg="white" borderRadius="lg" border="1px solid" borderColor="gray.100">
// //           <Flex justify="space-between" align="center">
// //             <Box>
// //               <Text fontSize="sm" color="gray.600" fontWeight="medium">
// //                 Total de Registros
// //               </Text>
// //               <Text fontSize="3xl" fontWeight="bold" color="blue.600">
// //                 {filtered.length}
// //               </Text>
// //             </Box>

// //             <Text fontSize="sm" color="gray.500">
// //               {filtered.length === rows.length 
// //                 ? "Todos os registros" 
// //                 : `${filtered.length} de ${rows.length} registros filtrados`}
// //             </Text>
// //           </Flex>
// //         </Box>
// //       </ContentCard>

// //       <ContentCard>
// //         <DataTable
// //           columns={columns}
// //           data={filtered}
// //           pagination
// //           highlightOnHover
// //           responsive
// //           fixedHeader
// //           progressPending={loading}
// //           noDataComponent="Nenhum registro encontrado"
// //           paginationComponentOptions={{
// //             rowsPerPageText: "Registros por página:",
// //             rangeSeparatorText: "de",
// //             selectAllRowsItemText: "Todos",
// //           }}
// //           customStyles={{
// //             headCells: { style: { fontWeight: "bold", fontSize: "13px", backgroundColor: "#f8fafc" } },
// //             cells: { style: { fontSize: "13px", whiteSpace: "normal", wordBreak: "break-word" } },
// //           }}
// //         />
// //       </ContentCard>

// //       <FormModal
// //         isOpen={isOpen}
// //         onClose={onClose}
// //         initialData={editing}
// //         onSave={async (data: any) => {
// //           try {
// //             if (editing) {
// //               await FichaService.update(editing.id, data);
// //             } else {
// //               await FichaService.create(data);
// //             }
// //             toast({ title: "Salvo com sucesso!", status: "success" });
// //             loadData();
// //           } catch {
// //             toast({ title: "Erro ao salvar ficha", status: "error" });
// //           } finally {
// //             onClose();
// //             setEditing(null);
// //           }
// //         }}
// //       />
// //     </Box>
// //   );
// // }

// import {
//   Box,
//   Flex,
//   IconButton,
//   Button,
//   Input,
//   Text,
//   Tooltip,
//   useDisclosure,
//   useToast,
//   Modal,
//   ModalOverlay,
//   ModalContent,
//   ModalHeader,
//   ModalBody,
//   ModalFooter,
//   Checkbox,
//   VStack,
// } from "@chakra-ui/react";

// import { FiEdit, FiPrinter, FiTrash2, FiSearch, FiX, FiColumns } from "react-icons/fi";

// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";

// import { useEffect, useMemo, useState } from "react";
// import DataTable from "react-data-table-component";

// import ContentCard from "../../components/common/ContentCard";
// import { PageHeader } from "../../components/common/PageHeader";
// import { FichaService } from "../../services/ficha.service";

// import FormModal from "./FormModal";

//   function handlePrint(ficha: any) {

//     const win = window.open("", "_blank", "width=900,height=700");

//     if (!win) return;

//     win.document.write(`
//     <html>
//       <head>
//         <title>Ficha</title>

//         <style>
//           body {
//             font-family: Arial, sans-serif;
//             padding: 20px;
//           }

//           .container {
//             border: 1px solid #000;
//             padding: 20px;
//           }

//           h2 {
//             text-align: center;
//             margin-bottom: 20px;
//           }

//           .row {
//             margin-bottom: 8px;
//             font-size: 14px;
//           }

//           .label {
//             font-weight: bold;
//           }

//           .grid {
//             display: grid;
//             grid-template-columns: 1fr 1fr;
//             gap: 10px;
//           }

//           .section {
//             margin-top: 15px;
//             padding-top: 10px;
//             border-top: 1px solid #000;
//           }
//         </style>

//       </head>

//       <body>

//         <div class="container">

//           <h2>FICHA DE CADASTRO</h2>

//           <div class="grid">

//             <div class="row"><span class="label">Nome:</span> ${ficha.nome || ""}</div>
//             <div class="row"><span class="label">CPF:</span> ${ficha.cpf || ""}</div>

//             <div class="row"><span class="label">RG:</span> ${ficha.rg || ""}</div>
//             <div class="row"><span class="label">Título:</span> ${ficha.titulo || ""}</div>

//             <div class="row"><span class="label">SUS:</span> ${ficha.cartao_sus || ""}</div>
//             <div class="row"><span class="label">Nascimento:</span> ${ficha.data_nascimento || ""}</div>

//             <div class="row"><span class="label">Mãe:</span> ${ficha.nome_mae || ""}</div>
//             <div class="row"><span class="label">Contato:</span> ${ficha.contato || ""}</div>

//           </div>

//           <div class="section">

//             <div class="row">
//               <span class="label">Liderança:</span>
//               ${ficha.numero_lideranca || ""} - ${ficha.lideranca_nome || ""}
//             </div>

//             <div class="row">
//               <span class="label">Zona:</span>
//               ${ficha.zona_numero || ""}
//             </div>

//             <div class="row">
//               <span class="label">Sessão:</span>
//               ${ficha.sessao_numero || ""} - ${ficha.sessao_descricao || ""}
//             </div>

//           </div>

//           <div class="section">

//             <div class="row">
//               <span class="label">Endereço:</span>
//               ${ficha.endereco || ""}, ${ficha.numero || ""}
//             </div>

//             <div class="row">
//               <span class="label">Bairro:</span> ${ficha.bairro || ""}
//             </div>

//             <div class="row">
//               <span class="label">Cidade:</span> ${ficha.cidade || ""}
//             </div>

//             <div class="row">
//               <span class="label">UF:</span> ${ficha.uf || ""}
//             </div>

//           </div>

//           <div class="section">

//             <div class="row">
//               <span class="label">Observação:</span><br/>
//               ${ficha.observacao || ""}
//             </div>

//           </div>

//         </div>

//         <script>
//           window.onload = function () {
//             setTimeout(() => {
//               window.print();
//             }, 300);
//           };
//         </script>

//       </body>
//     </html>
//   `);

//     win.document.close();
//     win.focus();
//   }

// type ExcelColumnDef = {
//   key: string;
//   label: string;
//   selector: (row: any) => any;
// };

// export function exportGridToExcel(rows: any[], fileName = "Cadastro_fichas.xlsx", columns?: ExcelColumnDef[]) {
//   if (!rows?.length) return;

//   const activeColumns = (columns && columns.length)
//     ? columns
//     : Object.keys(rows[0]).map((key) => ({
//       key,
//       label: key,
//       selector: (row: any) => row?.[key]
//     }));

//   const formatted = rows.map((row) => {
//     const data: Record<string, any> = {};

//     activeColumns.forEach((column) => {
//       const value = column.selector(row);
//       data[column.label] = value == null
//         ? ""
//         : typeof value === "object"
//           ? JSON.stringify(value)
//           : value;
//     });

//     return data;
//   });

//   const worksheet = XLSX.utils.json_to_sheet(formatted);
//   const workbook = XLSX.utils.book_new();
//   XLSX.utils.book_append_sheet(workbook, worksheet, "Dados");

//   const buffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
//   saveAs(new Blob([buffer]), fileName);
// }

// export default function ListPage() {
//   const toast = useToast();
//   const { isOpen, onOpen, onClose } = useDisclosure();
//   const {
//     isOpen: isColumnsOpen,
//     onOpen: onColumnsOpen,
//     onClose: onColumnsClose
//   } = useDisclosure();

//   const [rows, setRows] = useState<any[]>([]);
//   const [editing, setEditing] = useState<any>(null);
//   const [loading, setLoading] = useState(false);

//   const [filters, setFilters] = useState({
//     nome: "", ano: "", cpf: "", rg: "", titulo: "", cartao_sus: "", contato: "",
//     nome_mae: "", data_nascimento: "", lideranca: "", zona: "", zona_numero: "", sessao: "", sessao_numero: "",
//     endereco: "", bairro: "", cidade: "", uf: "", observacao: "",
//   });

//   const [openFilter, setOpenFilter] = useState<string | null>(null);

//   const columnDefs = [
//     { key: "ano", label: "Ano", selector: (r: any) => r.ano, minWidth: "90px", filterField: "ano" },
//     { key: "nome", label: "Nome", selector: (r: any) => r.nome, minWidth: "180px", wrap: true, filterField: "nome" },
//     { key: "cpf", label: "CPF", selector: (r: any) => r.cpf, minWidth: "140px", filterField: "cpf" },
//     { key: "rg", label: "RG", selector: (r: any) => r.rg, minWidth: "120px", filterField: "rg" },
//     { key: "titulo", label: "Título", selector: (r: any) => r.titulo, minWidth: "130px", filterField: "titulo" },
//     { key: "cartao_sus", label: "SUS", selector: (r: any) => r.cartao_sus, minWidth: "140px", filterField: "cartao_sus" },
//     { key: "data_nascimento", label: "Nascimento", selector: (r: any) => r.data_nascimento, minWidth: "130px", filterField: "data_nascimento" },
//     { key: "nome_mae", label: "Mãe", selector: (r: any) => r.nome_mae, minWidth: "160px", wrap: true, filterField: "nome_mae" },
//     { key: "contato", label: "Contato", selector: (r: any) => r.contato, minWidth: "160px", wrap: true, filterField: "contato" },
//     { key: "lideranca", label: "Liderança", selector: (r: any) => `${r.lideranca_nome || ""}`, minWidth: "180px", wrap: true, filterField: "lideranca" },
//     { key: "zona", label: "Zona", selector: (r: any) => `${r.zona_numero ?? ""} - ${r.zona_descricao || ""}`, minWidth: "180px", wrap: true, filterField: "zona" },
//     { key: "zona_numero", label: "Nº Zona", selector: (r: any) => r.zona_numero, minWidth: "90px", filterField: "zona_numero" },
//     { key: "sessao", label: "Sessão", selector: (r: any) => `${r.sessao_numero ?? ""} - ${r.sessao_descricao || ""}`, minWidth: "180px", wrap: true, filterField: "sessao" },
//     { key: "sessao_numero", label: "Nº Sessão", selector: (r: any) => r.sessao_numero, minWidth: "95px", filterField: "sessao_numero" },
//     { key: "endereco", label: "Endereço", selector: (r: any) => r.endereco, minWidth: "180px", wrap: true, filterField: "endereco" },
//     { key: "bairro", label: "Bairro", selector: (r: any) => r.bairro, minWidth: "140px", wrap: true, filterField: "bairro" },
//     { key: "cidade", label: "Cidade", selector: (r: any) => r.cidade, minWidth: "140px", wrap: true, filterField: "cidade" },
//     { key: "uf", label: "UF", selector: (r: any) => r.uf, minWidth: "80px", filterField: "uf" },
//     { key: "observacao", label: "Observação", selector: (r: any) => r.observacao, minWidth: "180px", wrap: true, filterField: "observacao" }
//   ];

//   const defaultVisibleColumns = columnDefs.map((column) => column.key);

//   const [visibleColumns, setVisibleColumns] = useState<string[]>(defaultVisibleColumns);

//   async function loadData() {
//     try {
//       setLoading(true);
//       const data = await FichaService.findAll();
//       const normalizedRows = Array.isArray(data)
//         ? data
//         : Array.isArray((data as any)?.data)
//           ? (data as any).data
//           : [];

//       setRows(normalizedRows);
//     } catch {
//       toast({ title: "Erro ao carregar fichas", status: "error" });
//     } finally {
//       setLoading(false);
//     }
//   }

//   useEffect(() => {
//     loadData();
//   }, []);

//   async function handleDelete(id: number) {
//     if (!confirm("Deseja excluir esta ficha?")) return;

//     try {
//       await FichaService.delete(id);
//       toast({ title: "Ficha excluída com sucesso", status: "success" });
//       loadData();
//     } catch {
//       toast({ title: "Erro ao excluir ficha", status: "error" });
//     }
//   }

//   const filtered = useMemo(() => {
//     const safeRows = Array.isArray(rows) ? rows : [];

//     return safeRows.filter((item) => {
//       const check = (field: any, filter: string) =>
//         String(field ?? "").toLowerCase().includes(filter.toLowerCase());

//       return (
//         check(item.ano, filters.ano) &&
//         check(item.nome, filters.nome) &&
//         check(item.cpf, filters.cpf) &&
//         check(item.rg, filters.rg) &&
//         check(item.titulo, filters.titulo) &&
//         check(item.cartao_sus, filters.cartao_sus) &&
//         check(item.contato, filters.contato) &&
//         check(item.nome_mae, filters.nome_mae) &&
//         check(item.data_nascimento, filters.data_nascimento) &&
//         check(item.lideranca_nome, filters.lideranca) &&
//         check(item.zona_numero, filters.zona_numero) &&
//         check(item.zona_descricao, filters.zona) &&
//         check(item.sessao_numero, filters.sessao_numero) &&
//         check(item.sessao_descricao, filters.sessao) &&
//         check(item.endereco, filters.endereco) &&
//         check(item.bairro, filters.bairro) &&
//         check(item.cidade, filters.cidade) &&
//         check(item.uf, filters.uf) &&
//         check(item.observacao, filters.observacao)
//       );
//     });
//   }, [rows, filters]);

//   function renderFilter(field: keyof typeof filters, label: string) {
//     return openFilter === field ? (
//       <Input
//         size="sm"
//         autoFocus
//         placeholder={`Filtrar ${label}`}
//         value={filters[field]}
//         onChange={(e) => setFilters({ ...filters, [field]: e.target.value })}
//         onBlur={() => setOpenFilter(null)}
//       />
//     ) : (
//       <Flex align="center" gap={2}>
//         <Text fontSize="sm" fontWeight="600">{label}</Text>
//         <IconButton
//           aria-label="filtro"
//           icon={<FiSearch />}
//           size="xs"
//           variant="ghost"
//           onClick={() => setOpenFilter(field)}
//         />
//       </Flex>
//     );
//   }

//   const columns = [
//     {
//       name: "Ações",
//       width: "160px",
//       cell: (row: any) => (
//         <Flex gap={2}>
//           <IconButton icon={<FiEdit />} size="sm" colorScheme="blue" onClick={() => { setEditing(row); onOpen(); }} />
//           <IconButton icon={<FiTrash2 />} size="sm" colorScheme="red" onClick={() => handleDelete(row.id)} />
//           <Tooltip label="Imprimir">
//             <IconButton icon={<FiPrinter />} size="sm" colorScheme="green" onClick={() => handlePrint(row)} />
//           </Tooltip>
//         </Flex>
//       ),
//     },

//     ...columnDefs
//       .filter((column) => visibleColumns.includes(column.key))
//       .map((column) => ({
//         name: renderFilter(column.filterField as keyof typeof filters, column.label),
//         selector: column.selector,
//         minWidth: column.minWidth,
//         wrap: column.wrap
//       })),
//     // {
//     //   name: "Ações",
//     //   width: "160px",
//     //   cell: (row: any) => (
//     //     <Flex gap={2}>
//     //       <IconButton icon={<FiEdit />} size="sm" colorScheme="blue" onClick={() => { setEditing(row); onOpen(); }} />
//     //       <IconButton icon={<FiTrash2 />} size="sm" colorScheme="red" onClick={() => handleDelete(row.id)} />
//     //       <Tooltip label="Imprimir">
//     //         <IconButton icon={<FiPrinter />} size="sm" colorScheme="green" onClick={() => handlePrint(row)} />
//     //       </Tooltip>
//     //     </Flex>
//     //   ),
//     // },
//   ];

//   const excelVisibleColumns = columnDefs
//     .filter((column) => visibleColumns.includes(column.key))
//     .map((column) => ({
//       key: column.key,
//       label: column.label,
//       selector: column.selector
//     }));

//   return (
//     <Box>
//       <PageHeader
//         title="Fichas"
//         onNew={() => { setEditing(null); onOpen(); }}
//         actions={
//           <>
//             <Button
//               size="sm"
//               variant="outline"
//               colorScheme="red"
//               leftIcon={<FiX />}
//               onClick={() => {
//                 setFilters({
//                   nome: "", ano: "", cpf: "", rg: "", titulo: "", cartao_sus: "", contato: "",
//                   nome_mae: "", data_nascimento: "", lideranca: "", zona: "", zona_numero: "", sessao: "", sessao_numero: "",
//                   endereco: "", bairro: "", cidade: "", uf: "", observacao: "",
//                 });
//                 setOpenFilter(null);
//               }}
//             >
//               Limpar filtros
//             </Button>

//             <Button
//               colorScheme="green"
//               size="sm"
//               onClick={() => exportGridToExcel(filtered, "Cadastro_fichas.xlsx", excelVisibleColumns)}
//             >
//               Exportar Excel
//             </Button>

//             <Button
//               size="sm"
//               leftIcon={<FiColumns />}
//               variant="outline"
//               onClick={onColumnsOpen}
//             >
//               Colunas
//             </Button>
//           </>
//         }
//       />

//       {/* Card Total - Compacto */}
//       <Flex justify="flex-start" mb={6}>
//         <ContentCard maxW="320px">
//           <Box p={4}>
//             <Text fontSize="sm" color="gray.600" fontWeight="medium">
//               Total de Registros
//             </Text>
//             <Text fontSize="3xl" fontWeight="bold" color="blue.600">
//               {filtered.length}
//             </Text>
//             {filtered.length !== rows.length && (
//               <Text fontSize="xs" color="gray.500" mt={1}>
//                 {filtered.length} de {rows.length} filtrados
//               </Text>
//             )}
//           </Box>
//         </ContentCard>
//       </Flex>

//       <ContentCard>
//         <DataTable
//           columns={columns}
//           data={filtered}
//           pagination
//           highlightOnHover
//           responsive
//           fixedHeader
//           progressPending={loading}
//           noDataComponent="Nenhum registro encontrado"
//           paginationComponentOptions={{
//             rowsPerPageText: "Registros por página:",
//             rangeSeparatorText: "de",
//             selectAllRowsItemText: "Todos",
//           }}
//           customStyles={{
//             headCells: { style: { fontWeight: "bold", fontSize: "13px", backgroundColor: "#f8fafc" } },
//             cells: { style: { fontSize: "13px", whiteSpace: "normal", wordBreak: "break-word" } },
//           }}
//         />
//       </ContentCard>

//       <Modal isOpen={isColumnsOpen} onClose={onColumnsClose}>
//         <ModalOverlay />
//         <ModalContent>
//           <ModalHeader>Colunas visíveis</ModalHeader>
//           <ModalBody>
//             <VStack align="stretch" spacing={2}>
//               {columnDefs.map((column) => (
//                 <Checkbox
//                   key={column.key}
//                   isChecked={visibleColumns.includes(column.key)}
//                   onChange={(e) => {
//                     const checked = e.target.checked;

//                     setVisibleColumns((prev) => {
//                       if (checked) {
//                         return Array.from(new Set([...prev, column.key]));
//                       }

//                       if (prev.length === 1 && prev.includes(column.key)) {
//                         return prev;
//                       }

//                       return prev.filter((key) => key !== column.key);
//                     });
//                   }}
//                 >
//                   {column.label}
//                 </Checkbox>
//               ))}
//             </VStack>
//           </ModalBody>
//           <ModalFooter>
//             <Button
//               mr={3}
//               variant="outline"
//               onClick={() => setVisibleColumns(defaultVisibleColumns)}
//             >
//               Restaurar padrão
//             </Button>
//             <Button colorScheme="blue" onClick={onColumnsClose}>
//               Fechar
//             </Button>
//           </ModalFooter>
//         </ModalContent>
//       </Modal>

//       <FormModal
//         isOpen={isOpen}
//         onClose={onClose}
//         initialData={editing}
//         onSave={async (data: any) => {
//           try {
//             if (editing) {
//               await FichaService.update(editing.id, data);
//             } else {
//               await FichaService.create(data);
//             }
//             toast({ title: "Salvo com sucesso!", status: "success" });
//             loadData();
//             onClose();
//             setEditing(null);
//             return true;
//           } catch (error: any) {
//             toast({
//               title: error?.response?.data?.error || "Erro ao salvar ficha",
//               status: "error"
//             });
//             return false;
//           }
//         }}
//       />
//     </Box>
//   );
// }

import {
  Box,
  Flex,
  IconButton,
  Button,
  Input,
  Text,
  Tooltip,
  useDisclosure,
  useToast,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Checkbox,
  VStack,
  Badge,
  SimpleGrid,
} from "@chakra-ui/react";

import {
  FiEdit,
  FiPrinter,
  FiTrash2,
  FiSearch,
  FiX,
  FiColumns,
  FiCheckCircle,
  FiSlash,
} from "react-icons/fi";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useEffect, useMemo, useState } from "react";
import DataTable from "react-data-table-component";

import ContentCard from "../../components/common/ContentCard";
import { PageHeader } from "../../components/common/PageHeader";
import { FichaService } from "../../services/ficha.service";
import FormModal from "./FormModal";

type ExcelColumnDef = {
  key: string;
  label: string;
  selector: (row: any) => any;
};

function handlePrint(ficha: any) {
  const win = window.open("", "_blank", "width=900,height=700");
  if (!win) return;

  const escapeHtml = (value: any) => String(value ?? "").replace(/[&<>"']/g, (char) => ({
    "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;"
  }[char] as string));

  win.document.write(`
    <html>
      <head>
        <title>Ficha</title>
        <style>
          body { font-family: Arial, sans-serif; padding: 20px; }
          .container { border: 1px solid #000; padding: 20px; }
          h2 { text-align: center; margin-bottom: 20px; }
          .row { margin-bottom: 8px; font-size: 14px; }
          .label { font-weight: bold; }
          .grid { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
          .section { margin-top: 15px; padding-top: 10px; border-top: 1px solid #000; }
        </style>
      </head>
      <body>
        <div class="container">
          <h2>FICHA DE CADASTRO</h2>
          <div class="grid">
            <div class="row"><span class="label">Nome:</span> ${escapeHtml(ficha.nome)}</div>
            <div class="row"><span class="label">CPF:</span> ${escapeHtml(ficha.cpf)}</div>
            <div class="row"><span class="label">RG:</span> ${escapeHtml(ficha.rg)}</div>
            <div class="row"><span class="label">Título:</span> ${escapeHtml(ficha.titulo)}</div>
            <div class="row"><span class="label">SUS:</span> ${escapeHtml(ficha.cartao_sus)}</div>
            <div class="row"><span class="label">Nascimento:</span> ${escapeHtml(ficha.data_nascimento)}</div>
            <div class="row"><span class="label">Mãe:</span> ${escapeHtml(ficha.nome_mae)}</div>
            <div class="row"><span class="label">Contato:</span> ${escapeHtml(ficha.contato)}</div>
          </div>
          <div class="section">
            <div class="row"><span class="label">Status:</span> ${escapeHtml((ficha.status || "ativo").toUpperCase())}</div>
            <div class="row"><span class="label">Liderança:</span> ${escapeHtml(ficha.numero_lideranca)} - ${escapeHtml(ficha.lideranca_nome)}</div>
            <div class="row"><span class="label">Zona:</span> ${escapeHtml(ficha.zona_numero)} - ${escapeHtml(ficha.zona_descricao)}</div>
            <div class="row"><span class="label">Sessão:</span> ${escapeHtml(ficha.sessao_numero)} - ${escapeHtml(ficha.sessao_descricao)}</div>
          </div>
          <div class="section">
            <div class="row"><span class="label">Endereço:</span> ${escapeHtml(ficha.endereco)}, ${escapeHtml(ficha.numero)}</div>
            <div class="row"><span class="label">Bairro:</span> ${escapeHtml(ficha.bairro)}</div>
            <div class="row"><span class="label">Cidade:</span> ${escapeHtml(ficha.cidade)}</div>
            <div class="row"><span class="label">UF:</span> ${escapeHtml(ficha.uf)}</div>
          </div>
          <div class="section"><div class="row"><span class="label">Observação:</span><br/>${escapeHtml(ficha.observacao)}</div></div>
        </div>
        <script>window.onload = function () { setTimeout(() => window.print(), 300); };</script>
      </body>
    </html>
  `);
  win.document.close();
  win.focus();
}

export function exportGridToExcel(
  rows: any[],
  fileName = "Cadastro_fichas.xlsx",
  columns?: ExcelColumnDef[]
) {
  if (!rows?.length) return;

  const activeColumns = columns?.length
    ? columns
    : Object.keys(rows[0]).map((key) => ({
        key,
        label: key,
        selector: (row: any) => row?.[key],
      }));

  const formatted = rows.map((row) => {
    const data: Record<string, any> = {};
    activeColumns.forEach((column) => {
      const value = column.selector(row);
      data[column.label] = value == null
        ? ""
        : typeof value === "object"
          ? JSON.stringify(value)
          : value;
    });
    return data;
  });

  const worksheet = XLSX.utils.json_to_sheet(formatted);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Dados");
  const buffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  saveAs(new Blob([buffer]), fileName);
}

export default function ListPage() {
  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isColumnsOpen,
    onOpen: onColumnsOpen,
    onClose: onColumnsClose,
  } = useDisclosure();

  const [rows, setRows] = useState<any[]>([]);
  const [editing, setEditing] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [statusLoadingId, setStatusLoadingId] = useState<number | null>(null);
  const [statusCardFilter, setStatusCardFilter] = useState<"todos" | "ativo" | "inativo">("todos");

  const [filters, setFilters] = useState({
    nome: "", ano: "", cpf: "", rg: "", titulo: "", cartao_sus: "", contato: "",
    nome_mae: "", data_nascimento: "", lideranca: "", zona: "", zona_numero: "",
    sessao: "", sessao_numero: "", endereco: "", bairro: "", cidade: "", uf: "",
    observacao: "", status: "",
  });
  const [openFilter, setOpenFilter] = useState<string | null>(null);

  const columnDefs = [
    { key: "ano", label: "Ano", selector: (r: any) => r.ano, minWidth: "90px", filterField: "ano" },
    { key: "nome", label: "Nome", selector: (r: any) => r.nome, minWidth: "180px", wrap: true, filterField: "nome" },
    { key: "status", label: "Status", selector: (r: any) => getStatus(r).toUpperCase(), minWidth: "100px", filterField: "status" },
    { key: "cpf", label: "CPF", selector: (r: any) => r.cpf, minWidth: "140px", filterField: "cpf" },
    { key: "rg", label: "RG", selector: (r: any) => r.rg, minWidth: "120px", filterField: "rg" },
    { key: "titulo", label: "Título", selector: (r: any) => r.titulo, minWidth: "130px", filterField: "titulo" },
    { key: "cartao_sus", label: "SUS", selector: (r: any) => r.cartao_sus, minWidth: "140px", filterField: "cartao_sus" },
    { key: "data_nascimento", label: "Nascimento", selector: (r: any) => r.data_nascimento, minWidth: "130px", filterField: "data_nascimento" },
    { key: "nome_mae", label: "Mãe", selector: (r: any) => r.nome_mae, minWidth: "160px", wrap: true, filterField: "nome_mae" },
    { key: "contato", label: "Contato", selector: (r: any) => r.contato, minWidth: "160px", wrap: true, filterField: "contato" },
    { key: "lideranca", label: "Liderança", selector: (r: any) => r.lideranca_nome || "", minWidth: "180px", wrap: true, filterField: "lideranca" },
    { key: "zona", label: "Zona", selector: (r: any) => `${r.zona_numero ?? ""} - ${r.zona_descricao || ""}`, minWidth: "180px", wrap: true, filterField: "zona" },
    { key: "zona_numero", label: "Nº Zona", selector: (r: any) => r.zona_numero, minWidth: "90px", filterField: "zona_numero" },
    { key: "sessao", label: "Sessão", selector: (r: any) => `${r.sessao_numero ?? ""} - ${r.sessao_descricao || ""}`, minWidth: "180px", wrap: true, filterField: "sessao" },
    { key: "sessao_numero", label: "Nº Sessão", selector: (r: any) => r.sessao_numero, minWidth: "95px", filterField: "sessao_numero" },
    { key: "endereco", label: "Endereço", selector: (r: any) => r.endereco, minWidth: "180px", wrap: true, filterField: "endereco" },
    { key: "bairro", label: "Bairro", selector: (r: any) => r.bairro, minWidth: "140px", wrap: true, filterField: "bairro" },
    { key: "cidade", label: "Cidade", selector: (r: any) => r.cidade, minWidth: "140px", wrap: true, filterField: "cidade" },
    { key: "uf", label: "UF", selector: (r: any) => r.uf, minWidth: "80px", filterField: "uf" },
    { key: "observacao", label: "Observação", selector: (r: any) => r.observacao, minWidth: "180px", wrap: true, filterField: "observacao" },
  ];

  const defaultVisibleColumns = columnDefs.map((column) => column.key);
  const getStatus = (row: any): "ativo" | "inativo" => row?.status === "inativo" ? "inativo" : "ativo";
  const totalAtivos = rows.filter((row) => getStatus(row) === "ativo").length;
  const totalInativos = rows.filter((row) => getStatus(row) === "inativo").length;
  const [visibleColumns, setVisibleColumns] = useState<string[]>(defaultVisibleColumns);

  async function loadData() {
    try {
      setLoading(true);
      const data = await FichaService.findAll();
      const normalizedRows = Array.isArray(data)
        ? data
        : Array.isArray((data as any)?.data)
          ? (data as any).data
          : [];
      setRows(normalizedRows);
    } catch {
      toast({ title: "Erro ao carregar fichas", status: "error" });
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => { loadData(); }, []);

  async function handleDelete(id: number) {
    if (!confirm("Deseja excluir esta ficha?")) return;
    try {
      await FichaService.delete(id);
      toast({ title: "Ficha excluída com sucesso", status: "success" });
      await loadData();
    } catch {
      toast({ title: "Erro ao excluir ficha", status: "error" });
    }
  }

  async function handleToggleStatus(row: any) {
    const nextStatus: "ativa" | "inativo" = getStatus(row) === "ativo" ? "inativo" : "ativa";
    const confirmation = nextStatus === "inativo"
      ? `Deseja inativar a ficha de ${row.nome || "este cadastro"}?`
      : `Deseja ativar novamente a ficha de ${row.nome || "este cadastro"}?`;
    if (!confirm(confirmation)) return;

    try {
      setStatusLoadingId(Number(row.id));
      await FichaService.updateStatus(Number(row.id), nextStatus);
      setRows((previous) => previous.map((item) =>
        Number(item.id) === Number(row.id) ? { ...item, status: nextStatus } : item
      ));
      toast({
        title: nextStatus === "ativa" ? "Ficha ativada com sucesso" : "Ficha inativada com sucesso",
        status: "success",
      });
    } catch (error: any) {
      toast({
        title: error?.response?.data?.error || "Erro ao alterar status da ficha",
        status: "error",
      });
    } finally {
      setStatusLoadingId(null);
    }
  }

  const filtered = useMemo(() => {
    const safeRows = Array.isArray(rows) ? rows : [];
    return safeRows.filter((item) => {
      const check = (field: any, filter: string) =>
        String(field ?? "").toLowerCase().includes(filter.toLowerCase());
      // O filtro dos cards atua sobre os registros já carregados em memória,
      // sem fazer nova consulta ao backend. getStatus normaliza "ativa" e "ativo".
      const normalizedStatus = getStatus(item);
      const matchesCardStatus = statusCardFilter === "todos" || normalizedStatus === statusCardFilter;

      return (
        matchesCardStatus &&
        check(item.ano, filters.ano) && check(item.nome, filters.nome) &&
        check(normalizedStatus, filters.status) && check(item.cpf, filters.cpf) &&
        check(item.rg, filters.rg) && check(item.titulo, filters.titulo) &&
        check(item.cartao_sus, filters.cartao_sus) && check(item.contato, filters.contato) &&
        check(item.nome_mae, filters.nome_mae) && check(item.data_nascimento, filters.data_nascimento) &&
        check(item.lideranca_nome, filters.lideranca) && check(item.zona_numero, filters.zona_numero) &&
        check(item.zona_descricao, filters.zona) && check(item.sessao_numero, filters.sessao_numero) &&
        check(item.sessao_descricao, filters.sessao) && check(item.endereco, filters.endereco) &&
        check(item.bairro, filters.bairro) && check(item.cidade, filters.cidade) &&
        check(item.uf, filters.uf) && check(item.observacao, filters.observacao)
      );
    });
  }, [rows, filters, statusCardFilter]);

  function renderFilter(field: keyof typeof filters, label: string) {
    return openFilter === field ? (
      <Input
        size="sm"
        autoFocus
        placeholder={`Filtrar ${label}`}
        value={filters[field]}
        onChange={(event) => setFilters((previous) => ({ ...previous, [field]: event.target.value }))}
        onBlur={() => setOpenFilter(null)}
      />
    ) : (
      <Flex align="center" gap={2}>
        <Text fontSize="sm" fontWeight="600">{label}</Text>
        <IconButton
          aria-label={`Filtrar ${label}`}
          icon={<FiSearch />}
          size="xs"
          variant="ghost"
          onClick={() => setOpenFilter(field)}
        />
      </Flex>
    );
  }

  const columns = [
    {
      name: "Ações",
      width: "230px",
      cell: (row: any) => {
        const active = getStatus(row) === "ativo";
        return (
          <Flex gap={1.5} align="center" flexWrap="wrap" py={1}>
            <Tooltip label="Editar os dados da ficha">
              <IconButton aria-label="Editar ficha" icon={<FiEdit />} size="sm" colorScheme="blue" onClick={() => { setEditing(row); onOpen(); }} />
            </Tooltip>
            <Tooltip label={active ? "Inativar ficha" : "Ativar ficha"}>
              <IconButton
                aria-label={active ? "Inativar ficha" : "Ativar ficha"}
                icon={active ? <FiSlash /> : <FiCheckCircle />}
                size="sm"
                colorScheme={active ? "red" : "green"}
                variant="ghost"
                isLoading={statusLoadingId === Number(row.id)}
                onClick={() => handleToggleStatus(row)}
              />
            </Tooltip>
            <Tooltip label="Excluir definitivamente">
              <IconButton aria-label="Excluir ficha" icon={<FiTrash2 />} size="sm" colorScheme="red" variant="ghost" onClick={() => handleDelete(row.id)} />
            </Tooltip>
            <Tooltip label="Imprimir ficha">
              <IconButton aria-label="Imprimir ficha" icon={<FiPrinter />} size="sm" colorScheme="green" variant="ghost" onClick={() => handlePrint(row)} />
            </Tooltip>
          </Flex>
        );
      },
    },
    ...columnDefs.filter((column) => visibleColumns.includes(column.key)).map((column) => ({
      name: renderFilter(column.filterField as keyof typeof filters, column.label),
      selector: column.selector,
      minWidth: column.minWidth,
      wrap: (column as any).wrap,
      cell: column.key === "status" ? (row: any) => (
        <Badge colorScheme={getStatus(row) === "inativo" ? "red" : "green"}>
          {getStatus(row) === "inativo" ? "Inativo" : "Ativo"}
        </Badge>
      ) : undefined,
    })),
  ];

  const excelVisibleColumns: ExcelColumnDef[] = columnDefs
    .filter((column) => visibleColumns.includes(column.key))
    .map((column) => ({ key: column.key, label: column.label, selector: column.selector }));

  function clearFilters() {
    setFilters({
      nome: "", ano: "", cpf: "", rg: "", titulo: "", cartao_sus: "", contato: "",
      nome_mae: "", data_nascimento: "", lideranca: "", zona: "", zona_numero: "",
      sessao: "", sessao_numero: "", endereco: "", bairro: "", cidade: "", uf: "",
      observacao: "", status: "",
    });
    setOpenFilter(null);
    setStatusCardFilter("todos");
  }

  return (
    <Box>
      <PageHeader
        title="Fichas"
        onNew={() => { setEditing(null); onOpen(); }}
        actions={
          <>
            <Button size="sm" variant="outline" colorScheme="red" leftIcon={<FiX />} onClick={clearFilters}>
              Limpar filtros
            </Button>
            <Button colorScheme="green" size="sm" onClick={() => exportGridToExcel(filtered, "Cadastro_fichas.xlsx", excelVisibleColumns)}>
              Exportar Excel
            </Button>
            <Button size="sm" leftIcon={<FiColumns />} variant="outline" onClick={onColumnsOpen}>
              Colunas
            </Button>
          </>
        }
      />

      <SimpleGrid columns={{ base: 1, sm: 2, xl: 3 }} spacing={4} mb={6}>
        <Box
          as="button" type="button" textAlign="left" border="1px solid" borderColor={statusCardFilter === "todos" ? "blue.400" : "gray.200"}
          borderRadius="lg" bg="white" boxShadow="sm" p={4} cursor="pointer" transition="all 0.15s"
          _hover={{ shadow: "md", borderColor: "blue.300" }} onClick={() => setStatusCardFilter("todos")}
          aria-pressed={statusCardFilter === "todos"}
        >
          <Text fontSize="sm" color="gray.600" fontWeight="medium">Total de Registros</Text>
          <Text fontSize="3xl" fontWeight="bold" color="blue.600">{rows.length}</Text>
          <Text fontSize="xs" color="gray.500" mt={1}>{statusCardFilter === "todos" ? "Exibindo todos os status" : "Clique para remover o filtro de status"}</Text>
        </Box>
        <Box
          as="button" type="button" textAlign="left" border="1px solid" borderColor={statusCardFilter === "ativo" ? "green.400" : "gray.200"}
          borderRadius="lg" bg={statusCardFilter === "ativo" ? "green.50" : "white"} boxShadow="sm" p={4} cursor="pointer" transition="all 0.15s"
          _hover={{ shadow: "md", borderColor: "green.300" }} onClick={() => setStatusCardFilter(statusCardFilter === "ativo" ? "todos" : "ativo")}
          aria-pressed={statusCardFilter === "ativo"}
        >
          <Flex align="center" justify="space-between">
            <Text fontSize="sm" color="gray.600" fontWeight="medium">Fichas Ativas</Text>
            <Badge colorScheme="green">ATIVO</Badge>
          </Flex>
          <Text fontSize="3xl" fontWeight="bold" color="green.600">{totalAtivos}</Text>
          <Text fontSize="xs" color="gray.500" mt={1}>{statusCardFilter === "ativo" ? "Filtro ativo — clique para limpar" : "Clique para ver somente as fichas ativas"}</Text>
        </Box>
        <Box
          as="button" type="button" textAlign="left" border="1px solid" borderColor={statusCardFilter === "inativo" ? "red.400" : "gray.200"}
          borderRadius="lg" bg={statusCardFilter === "inativo" ? "red.50" : "white"} boxShadow="sm" p={4} cursor="pointer" transition="all 0.15s"
          _hover={{ shadow: "md", borderColor: "red.300" }} onClick={() => setStatusCardFilter(statusCardFilter === "inativo" ? "todos" : "inativo")}
          aria-pressed={statusCardFilter === "inativo"}
        >
          <Flex align="center" justify="space-between">
            <Text fontSize="sm" color="gray.600" fontWeight="medium">Fichas Inativas</Text>
            <Badge colorScheme="red">INATIVO</Badge>
          </Flex>
          <Text fontSize="3xl" fontWeight="bold" color="red.600">{totalInativos}</Text>
          <Text fontSize="xs" color="gray.500" mt={1}>{statusCardFilter === "inativo" ? "Filtro ativo — clique para limpar" : "Clique para ver somente as fichas inativas"}</Text>
        </Box>
      </SimpleGrid>

      <ContentCard>
        <DataTable
          columns={columns}
          data={filtered}
          conditionalRowStyles={[
            {
              when: (row: any) => getStatus(row) === "inativo",
              style: {
                backgroundColor: "#fff1f0",
                color: "#5c2626",
                "&:hover": { backgroundColor: "#ffe3e0 !important" },
              },
            },
          ]}
          pagination
          highlightOnHover
          responsive
          fixedHeader
          progressPending={loading}
          noDataComponent="Nenhum registro encontrado"
          paginationComponentOptions={{
            rowsPerPageText: "Registros por página:",
            rangeSeparatorText: "de",
            selectAllRowsItemText: "Todos",
          }}
          customStyles={{
            headCells: { style: { fontWeight: "bold", fontSize: "13px", backgroundColor: "#f8fafc" } },
            cells: { style: { fontSize: "13px", whiteSpace: "normal", wordBreak: "break-word" } },
          }}
        />
      </ContentCard>

      <Modal isOpen={isColumnsOpen} onClose={onColumnsClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Colunas visíveis</ModalHeader>
          <ModalBody>
            <VStack align="stretch" spacing={2}>
              {columnDefs.map((column) => (
                <Checkbox
                  key={column.key}
                  isChecked={visibleColumns.includes(column.key)}
                  onChange={(event) => {
                    const checked = event.target.checked;
                    setVisibleColumns((previous) => {
                      if (checked) return Array.from(new Set([...previous, column.key]));
                      if (previous.length === 1 && previous.includes(column.key)) return previous;
                      return previous.filter((key) => key !== column.key);
                    });
                  }}
                >
                  {column.label}
                </Checkbox>
              ))}
            </VStack>
          </ModalBody>
          <ModalFooter>
            <Button mr={3} variant="outline" onClick={() => setVisibleColumns(defaultVisibleColumns)}>Restaurar padrão</Button>
            <Button colorScheme="blue" onClick={onColumnsClose}>Fechar</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <FormModal
        isOpen={isOpen}
        onClose={onClose}
        initialData={editing}
        onSave={async (data: any, imageFile?: File | null) => {
          try {
            if (editing) {
              await FichaService.update(editing.id, { ...data, imageFile });
            } else {
              await FichaService.create({ ...data, imageFile });
            }
            toast({ title: "Ficha salva com sucesso!", status: "success" });
            await loadData();
            onClose();
            setEditing(null);
            return true;
          } catch (error: any) {
            toast({
              title: error?.response?.data?.error || error?.message || "Erro ao salvar ficha",
              status: "error",
            });
            return false;
          }
        }}
      />
    </Box>
  );
}
